import type { Translation } from '../i18n-types';
import baseLanguageValues from '../en-US';

export const translationValues: Partial<Translation> = {
    SHEETS: 'Preglednice',
    DASHBOARDS: 'Nadzorne plošče',
    DATABASE_TABLE: 'Podatkovna tabela',
    VARIABLES: 'Spremenljivke',
    FILES: 'Datoteke',
    APPS: 'Aplikacije',
    LABEL: 'Oznaka',
    EDIT_TYPE: 'Vrsta urejanja',
    EDITING_ROW: 'Urejanje vrstice {label}',
    CREATE_NEW_ROW: 'Ustvari novo vrstico',
    ADD: 'Dodaj',
    MULTIPLY: 'Pomnoži',
    SET: 'Nastavi',
    PERCENT_CHANGE: 'Odstotna sprememba',
    NAME: 'Ime',
    NAME_AND_STYLE: 'Ime in slog',
    PATH: 'Pot',
    SHARE_WITH: 'Deli z',
    SUBMIT: 'Oddaj',
    EDIT: 'Uredi',
    ANY: 'Katerikoli',
    VIEW: 'Ogled',
    EDITING: 'Urejanje',
    DUPLICATE: 'Podvoji',
    DUPLICATE_SHEET_LOADING: 'Podvajanje preglednice...',
    DUPLICATE_SHEET_SUCCESS: 'Preglednica uspešno podvojena',
    DUPLICATE_SHEET_ERROR: 'Napaka pri podvajanju preglednice',
    DUPLICATE_FOLDER_LOADING: 'Podvajanje mape...',
    DUPLICATE_FOLDER_SUCCESS: 'Mapa uspešno podvojena',
    DUPLICATE_FOLDER_ERROR: 'Napaka pri podvajanju mape',
    DELETE_TILE: 'Izbriši ploščico',
    MATCH_CASE: 'Razlikuj velike/male črke',
    SEARCH: 'Iskanje',
    SEARCH_VALUES: 'Iskanje vrednosti',
    IMPORT: 'Uvoz',
    MODEL_HEALTH: 'Zdravje modela',
    CHECKLIST: 'Kontrolni seznam',
    DYNAMIC_ANALYSIS: 'Dinamična analiza',
    STATIC_ANALYSIS: 'Statična analiza',
    CALCULATION_LOGS: 'Dnevniki izračunov',
    ERROR_MESSAGE: 'Sporočilo o napaki',
    CALCULATION_TIME_MS: 'Čas izračuna (ms)',
    ERRORS: 'Napake',
    WARNINGS: 'Opozorila',
    AMPLIFICATION_FACTOR: 'Faktor ojačitve',
    CELL_COUNT_ESTIMATE: 'Število celic (ocena)',
    NO_CALCULATION_ERRORS: 'Ni napak v izračunih',
    CALCULATION_ERRORS: 'Najdene napake v izračunih',
    NO_MODELLING_ERRORS: 'Ni napak v modeliranju',
    MODELLING_ERRORS: 'Najdene napake v modeliranju',
    MODEL_FULLY_LOADED: 'Model v celoti naložen',
    MODEL_NOT_LOADED: 'Model ni naložen',
    SHARING: 'Deljenje',
    ASSIGNMENT: 'Naloga',
    ASSIGNMENTS: 'Naloge',
    LOAD_MORE: 'Naloži več',
    SHARES: 'Delnice',
    SHARE: 'Deli',
    OPEN: 'Odpri',
    NONE: 'Brez',
    TABLE: 'Tabela',
    VALUE: 'Vrednost',
    DATE: 'Datum',
    NONE_SELECTED: 'Nič izbrano',
    VALUE_FOR_MONTH: 'Vrednost za mesec',
    DESCRIPTION: 'Opis',
    NOTES: 'Opombe',
    CUSTOM_FIELD: 'Prilagojeno polje',
    TABLE_DESCRIPTION: 'Opis tabele',
    EDIT_COLUMN: 'Uredi stolpec',
    COLUMN_TYPE: 'Vrsta stolpca',
    MONTH: 'Mesec',
    VARIABLE_AND_DIMENSIONS: 'Spremenljivka in dimenzije',
    SHOW_UNMAPPED: 'Izberi samo nepovezane elemente',
    MANUAL_MAPPING: 'Ročno povezovanje',
    CLEAR: 'Počisti',
    AUTODETECT: 'Samodejno zaznaj',
    FILTER: 'Filter',
    SELECT_ALL_BRACKETS: '(Izberi vse)',
    BLANK_CELLS_BRACKETS: '(Prazne celice)',
    SELECT_DIMENSIONS: 'Izberi dimenzije',
    CONFIRM: 'Potrdi',
    REMOVE_ALL_MAPPINGS_CONFIRM: 'Ali ste prepričani, da želite odstraniti vse povezave?',
    REMOVE_MANUALLY_ADDED_MAPPING_TAGS: 'To dejanje bo odstranilo vse ročno dodane oznake povezav.',
    ERROR_IMPORTING_FILE: 'Napaka pri uvozu datoteke',
    CHOOSE_JOB_TO_REPLACE: 'Izberite opravilo za zamenjavo',
    PREVIOUS_IMPORTS: 'Prejšnji uvozi',
    WELCOME_TO_IMPORT: 'Dobrodošli v Uvoz.',
    IMPORT_SPREADSHEETS: 'Uvozite svoje preglednice iz Excela neposredno v Farseer in jih upravljajte.',
    DRAG_FILE_HERE: 'Povlecite datoteko sem',
    BROWSE: 'Prebrskaj',
    IMPORT_MISSING_MEMBERS: 'Uvozi manjkajoče člane',
    IMPORT_VALUES: 'Uvozi vrednosti',
    NO_COLUMN_SET_AS_TABLE: 'Noben stolpec ni nastavljen kot dimenzijska tabela',
    NO_COLUMN_SET_AS_VALUE: 'Noben stolpec ni nastavljen kot vrednost',
    MISSING_MEMBERS: 'Manjkajo člani dimenzij',
    SELECT_ALL: 'Izberi vse',
    DESCRIPTION_COLUMN: 'Stolpec z opisom',
    CONNECTED_DIMENSIONS_COLUMN: 'Stolpec povezanih dimenzij',
    CANCEL: 'Prekliči',
    CONTINUE: 'Nadaljuj',
    CREATE_DIMENSIONS: 'Ustvari dimenzije',
    SELECT_CONNECTION: 'Izberi povezavo',
    CLOSE: 'Zapri',
    SAVE: 'Shrani',
    DELETE: 'Izbriši',
    REMOVE: 'Odstrani',
    DELETING_ASSIGNMENT: 'Brisanje naloge{multiple} ...',
    DELETED_ASSIGNMENT: 'Naloga{multiple} izbrisana!',
    FAILED_DELETE_ASSIGNMENT: 'Brisanje naloge{multiple} ni uspelo',
    DELETE_ASSIGNMENT: 'Izbriši nalogo{multiple}',
    DELETE_ASSIGNMENT_CONFIRMATION: 'Ali želite izbrisati izbrano nalogo{multiple}?',
    COLUMNS: 'Stolpci',
    FORMATTING: 'Oblikovanje',
    PRESERVE_FORMATTING: 'Ohrani oblikovanje',
    CUSTOM_FORMATTING: 'Prilagojeno oblikovanje',
    GROUP_OUTLIERS: 'Združi odstopajoče vrednosti',
    VERSIONS: 'Različice',
    NONE_VERSION: 'Brez',
    APPLY_TO_ALL_YEARS: 'Uporabi za vsa leta',
    SHEET_OPTIONS: 'Možnosti preglednice',
    DASHBOARD_OPTIONS: 'Možnosti nadzorne plošče',
    LOCK_GRID: 'Zakleni mrežo',
    RESPONSIVE_LAYOUT: 'Odzivna postavitev',
    AUTO_REFRESH_DASHBOARD: 'Samodejno osveževanje nadzorne plošče',
    REFRESH_DASHBOARD: 'Osveži nadzorno ploščo',
    ONLY_WITH_DATA: 'Samo s podatki',
    OWD_INCLUDE_MEASURES: 'Vključi mere',
    SHOW_NO_RESULT_ROWS: 'Prikaži vrstice "No Result"',
    STACKED: 'Naloženo',
    TIMELINE: 'Časovnica',
    RESET_COLUMN_ORDER: 'Ponastavi vrstni red stolpcev',
    STANDARD_COLUMNS_NAME: 'Ime',
    STANDARD_COLUMNS_DESCRIPTION: 'Opis',
    STANDARD_COLUMNS_NAME_PLUS_DESCRIPTION: 'Ime + opis',
    DOWNLOADING_FILE: 'Prenašanje datoteke',
    FILE_DOWNLOADED: 'Datoteka prenesena',
    FAIL_FILE_DOWNLOAD: 'Izvoz iz dane konfiguracije ni uspel',
    ADD_TO_DASHBOARD: 'Dodaj na nadzorno ploščo',
    COPY_TO_DASHBOARD: 'Kopiraj na Nadzorno ploščo',
    SUBMIT_ENTRIES_CONFIRMATION: 'Ali ste prepričani, da želite oddati svoje vnose?',
    FURTHER_CHANGES_AND_LINK_LOCKED_AFTER_SUBMIT: 'Po oddaji ne boste mogli več spreminjati in povezava bo zaklenjena.',
    LINK_NOT_FOUND: 'Povezava ni najdena.',
    LINK_EXPIRED: 'Ta povezava je potekla.',
    DEPLOYMENT: 'Namestitev',
    UNKNOWN: 'Neznano',
    FILE_SIZE_10GB: 'Velikost datoteke > 10GB',
    FILE_SIZE_64MB: 'Velikost datoteke > 64MB',
    FILE_SIZE_1MB: 'Velikost datoteke > 1MB',
    FILE_SIZE_TOO_LARGE: 'Velikost datoteke je prevelika',
    LINK_URL_PLACEHOLDER: 'Prilepite povezavo in pritisnite Enter',
    LINK_URL_INVALID: 'Povezava se mora začeti s https://, http:// ali #/',
    UPLOADED: 'Naloženo',
    ERROR_UPLOADING_FILE: 'Napaka pri nalaganju datoteke',
    FOLDER_NAME: 'Ime mape',
    NEW_DIMENSION_TABLE: 'Nova dimenzijska tabela',
    NEW_VARIABLE: 'Nova spremenljivka',
    NEW_DASHBOARD: 'Nova nadzorna plošča',
    NEW_SHEET: 'Nova preglednica',
    UPLOAD_FILE: 'Naloži datoteko',
    NEW_FOLDER: 'Nova mapa',
    NEW_REMOTE_JOB: 'Nova aplikacija',
    DOWNLOAD: 'Prenesi',
    DELETE_MENU_ITEM_CONFIRM: 'Ali ste prepričani, da želite izbrisati {menuItem}?',
    USER_REMOVED: 'Uporabnik je bil odstranjen!',
    FAILED_USER_REMOVE: 'Odstranitev uporabnika ni uspela',
    USER_DELETING: 'Brisanje uporabnika {fullName}',
    USER_DELETING_CONFIRM: 'Ali ste prepričani, da želite izbrisati uporabnika {fullName}?',
    CONFIRM_DELETE_OPERATION: 'Potrdite operacijo brisanja',
    DELETE_YEAR_CONFIRMATION: 'Ali ste prepričani, da želite izbrisati leto {year}?',
    DELETE_VARIATION_CONFIRMATION: 'Ali ste prepričani, da želite izbrisati različico {name}?',
    YEARS: 'Leta',
    YEAR: 'Leto',
    ADD_YEAR: 'Dodaj {year}',
    OPTIONS: 'Možnosti',
    NO_VERSION_SELECTED: 'Nobena različica ni izbrana',
    INTERVAL_START_GREATER: 'Začetek intervala je večji od nekaterih koncev intervalov',
    INTERVAL_END_GREATER: 'Konec intervala je manjši od nekaterih začetkov intervalov',
    INTERVAL_START_GREATED_END: 'Začetek intervala je večji od konca',
    NO_NAME_INPUT: 'Naloga mora imeti ime',
    EDIT_ASSIGNMENTS: 'Uredi naloge',
    ASSIGNMENT_NAME: 'Ime naloge',
    VERSION: 'Različica',
    ADD_VERSION: 'Dodaj različico',
    ADD_NEW_VERSION: 'Dodaj novo različico',
    NEW_VERSION_NAME: 'Ime nove različice',
    ERROR_ADDING_VERSION: 'Napaka pri dodajanju različice.',
    NAME_AND_COLOR: 'Ime in barva',
    ADDED_BY: 'Dodal',
    CREATE_SERVICE_USER: 'Ustvari storitvenega uporabnika',
    CREATE_USER: 'Ustvari uporabnika',
    USER_TYPE: 'Vrsta uporabnika',
    STANDARD: 'Standardni',
    SERVICE: 'Storitev',
    CREATED_SERVICE_USER: 'Storitveni uporabnik ustvarjen',
    FAILED_CREATE_SERVICE_USER: 'Ustvarjanje storitvenega uporabnika in API ključa ni uspelo',
    SERVICE_USER_NAME_REQUIRED: 'Ime storitvenega uporabnika je obvezno',
    CREATED_USER: 'Uporabnik ustvarjen',
    FAILED_CREATE_USER: 'Ustvarjanje uporabnika ni uspelo',
    LAST_NAME_REQUIRED: 'Priimek je obvezen',
    FIRST_NAME_REQUIRED: 'Ime je obvezno',
    EMAIL_REQUIRED: 'E-pošta je obvezna',
    PASSWORD_REQUIRED: 'Geslo je obvezno',
    PASSWORD_INCORRECT: 'Geslo je napačno',
    FIRST_NAME: 'Ime',
    LAST_NAME: 'Priimek',
    EMAIL: 'E-pošta',
    PASSWORD: 'Geslo',
    CONFIRM_PASSWORD: 'Potrdi geslo',
    API_KEY: 'API ključ',
    CREATED_SERVICE_USER_API_KEY: 'API ključ storitvenega uporabnika {serviceUserName} ustvarjen',
    API_KEY_COPIED_TO_CLIPBOARD: 'API ključ kopiran v odložišče',
    MANAGE_API_KEYS: 'Upravljanje API ključev',
    API_KEYS_FOR_USER: 'API ključi – {name}',
    API_KEYS_SHOWN_ONCE: 'Ključi so prikazani samo enkrat, ob ustvarjanju.',
    API_KEYS_ROTATE_HINT: 'Za zamenjavo ključa ustvarite novega, posodobite integracijo in nato izbrišite starega.',
    API_KEYS_EMPTY: 'Ta uporabnik nima API ključev.',
    CREATE_API_KEY: 'Ustvari API ključ',
    EDIT_API_KEY: 'Uredi API ključ',
    API_KEY_UPDATED: 'API ključ posodobljen',
    CREATE_SERVICE_USER_API_KEY: 'Ustvari API ključ',
    API_KEY_CREATED: 'API ključ ustvarjen',
    API_KEY_COPY_NOW: 'Kopirajte ključ zdaj. Ponovno ne bo prikazan.',
    API_KEY_UNTITLED: 'Ključ brez imena',
    API_KEY_DESCRIPTION_PLACEHOLDER: 'npr. SAP izvoz – produkcija',
    API_KEY_CREATED_AT: 'Ustvarjeno',
    API_KEY_CREATED_BY: 'Ustvaril',
    API_KEY_EXPIRES: 'Poteče',
    API_KEY_EXPIRY: 'Potek',
    API_KEY_EXPIRY_IN_PAST: 'Potek mora biti v prihodnosti',
    API_KEY_NEVER_EXPIRES: 'Nikoli',
    API_KEY_EXPIRES_IN_DAYS: 'čez {days} {{dan|dni}}',
    API_KEY_EXPIRES_TODAY: 'Poteče danes',
    API_KEY_EXPIRED_ON: 'Poteklo {date}',
    API_KEY_MANAGED_BY_OVERSEER: 'Upravlja Overseer',
    API_KEY_MANAGED_BY_OVERSEER_HINT: 'Zamenja ga podpora Farseer. Tukaj ga ni mogoče urejati ali izbrisati.',
    API_KEY_DELETE_QUESTION: 'Izbrišem API ključ »{name}«? Integracije, ki ga uporabljajo, takoj prenehajo delovati.',
    API_KEY_DELETED: 'API ključ izbrisan',
    CONNECT: 'Poveži',
    DISCONNECT: 'Prekini povezavo',
    MIXED_VERSIONS: 'Mešane različice',
    MIXED: 'Mešano',
    USE_RESTRICTIONS: 'Omeji vnos na različice in intervale',
    ALLOW_ENTRY_ON_PROPERTY_COLUMNS: 'Dovoli vnos v stolpce lastnosti',
    PROPERTY_COLUMNS: 'Stolpci lastnosti',
    USE_TIME_LIMIT: 'Uporabi časovno omejitev',
    SELECT_VERSION: 'Izberite različico',
    EXPIRES_AFTER: 'Poteče po',
    CHANGE: 'Spremeni',
    SMART_FILTER_CHANGE: 'Sprememba',
    CHANGES_SUBMITTED: 'Spremembe oddane. Čakanje na pregled.',
    SUBMITTED: 'Oddano',
    ASSIGNMENTS_AVAILABLE: 'naloge na voljo',
    SUBMITTING_ASSIGNMENT: 'Oddajanje naloge.',
    SUBMITED_ASSIGNMENT: 'Naloga je oddana.',
    FAIL_SUBMIT_ASSIGNMENT: 'Oddaja naloge ni uspela.',
    ASSIGNMENT_LABEL_CREATED: 'Oznaka ustvarjena in dodana nalogi',
    SUBMIT_CHANGES: 'Oddaj spremembe?',
    SUBMIT_CHANGES_CONFIRMATION: 'Ali ste prepričani, da želite oddati svoje spremembe? Po oddaji ne boste mogli več urejati, postopek bo označen kot pripravljen za pregled in lastnik te preglednice bo obveščen.',
    CANT_UNDONE_ACTION: 'Tega dejanja ni mogoče razveljaviti.',
    APP_LANGUAGE: 'Jezik aplikacije',
    TARGET_VERSION_SAME_AS_SOURCE_VERSION_ERROR: 'Ciljna različica ne more biti enaka izvorni različici.',
    TARGET_VERSION: 'Ciljna različica',
    SELECT_TARGET_VERSION: 'Prosimo, izberite ciljno različico.',
    SOURCE_VERSION: 'Izvorna različica',
    SELECT_SOURCE_VERSION: 'Prosimo, izberite izvorno različico.',
    ROW_TAGS: 'Oznake vrstic',
    DELETE_THIS_ROW: 'Izbriši to vrstico',
    SELECT_PARENT_TAG_FOR_MULTIPLE_ROWS_GENERATING: 'Izberite nadrejeno oznako za ustvarjanje več vrstic',
    GLOBAL_SEARCH_PLACEHOLDER: 'Išči preglednice, nadzorne plošče, podatkovne tabele, aplikacije in spremenljivke',
    NO_RESULTS_FOUND: 'Ni najdenih rezultatov.',
    NEW_TILE: 'Nova ploščica',
    SLICER_STATE_SAVED: 'Stanje rezalnika shranjeno za vse!',
    INVALID_LINK: 'Neveljavna povezava',
    LINK_NOT_EXIST: 'Povezava ne obstaja.',
    ACCESS_NOT_GRANTED: 'Dostop do gostitelja ni odobren.',
    CONTACT_ADMIN: 'Za več informacij se obrnite na skrbnika.',
    LOGOUT: 'Odjava',
    REGENERATING_LINKS: 'Ponovno ustvarjanje povezav...',
    REGENERATED: 'Ponovno ustvarjeno!',
    FAILED_REGENERATING_LINKS: 'Ponovno ustvarjanje povezav za izbrane javne naloge ni uspelo.',
    REGENERATING_LINKS_SELECTED_ASSIGNMENTS: 'Ponovno ustvari povezave za izbrane naloge?',
    REGENERATING_LINKS_SELECTED_ASSIGNMENTS_CONFIRMATION: 'Ali ste prepričani, da želite ponovno ustvariti povezave za izbrane naloge? Stare povezave bodo neveljavne. Tega dejanja ni mogoče razveljaviti.',
    REGENERATE: 'Ponovno ustvari',
    REGENERATE_LINK: 'Ponovno ustvari povezavo',
    SHEET_NOT_FOUND: 'Preglednica ni najdena',
    CLUSTER_NOT_FOUND: 'Grozd ni najden',
    PARENT_CLUSTER_NOT_FOUND: 'Nadrejeni grozd ni najden',
    TAG_NOT_FOUND: 'Oznaka ni najdena',
    SHEET_ID_NOT_FOUND: 'ID preglednice ni najden',
    FAIL_CREATE_ROW: 'Ustvarjanje vrstice ni uspelo',
    FAIL_CREATE_CLUSTER: 'Ustvarjanje grozda ni uspelo',
    ROW_CREATED: 'Vrstica ustvarjena',
    COLUMN_CREATED: 'Stolpec ustvarjen',
    DIMENSION_CREATED: 'Dimenzija ustvarjena',
    NOT_IMPLEMENTED_YET: 'Še ni implementirano',
    VARIABLE_SHOULD_CONTAIN_ONLY_VARIABLES: 'Polje spremenljivke naj vsebuje samo spremenljivke',
    UNKNOWN_ZONE_SINGLE_VALUE: 'Neznano območje v posamezni vrednosti',
    FILTER_FIELD_SHOULD_CONTAIN_DIMENSION_TAGS: 'Polje filtra naj vsebuje oznake dimenzij',
    UNKNOWN_ZONE_DATA_EDITOR: 'Neznano območje v urejevalniku podatkov',
    VARIABLE_FILED_SHOULD_CONTAIN_ACCOUNT_TAG: 'Polje spremenljivke naj vsebuje oznake računov',
    CUSTOM_COLUMN_NOT_FOUND: 'Prilagojen stolpec ni najden',
    CANT_ADD_TO_COLUMN: 'Ni mogoče dodati {tagType} v stolpec vrste {columnType}',
    TAG_ALREADY_ADDED: 'Ta oznaka je že dodana',
    MODEL_IMPORT_IN_PROGRESS: 'Uvoz modela v teku...',
    MODEL_IMPORT_SUCCESS: 'Model uspešno uvožen.',
    CODE_EDITOR_ALLOW_CHANGES: 'Dovolite urejevalniku kode spreminjanje modela:',
    ALLOW_ALL: 'Dovoli vse',
    DELETE_MEMBER_ROWS: 'Izbriši vrstice',
    DELETE_TABLES: 'Izbriši tabele',
    DELETE_VARIABLES: 'Izbriši spremenljivke',
    DELETE_COLUMNS: 'Izbriši stolpce',
    DELETE_EVERYTHING: 'Izbriši vse ob uporabi sprememb',
    DRY_RUN: 'Poskusni zagon',
    MODEL_CODE_EDITOR: 'Urejevalnik kode modela',
    MODEL_IMPORT_EXPORT: 'Uvoz/izvoz modela',
    MODEL_IMPORT: 'Uvoz modela',
    MODEL_EXPORT: 'Izvoz modela',
    MODEL_USE_IN_EXPORT: 'Uporabi pri izvozu',
    MODEL_OBJECT_TYPE: {
        DTAB: 'Dimenzijske tabele',
        DMEM: 'Člani dimenzij',
        VAR: 'Spremenljivke',
        CELL: 'Celice',
    },
    LOADING: 'Nalaganje...',
    CHAT_STATUS_ANALYZING_CONTEXT: 'Analiziranje vašega vprašanja',
    CHAT_STATS_ACTIONS: '{count} {{dejanje|dejanja}}',
    CHAT_STATS_CONTEXT: '{tokens} kontekst',
    CHAT_STATS_DURATION_TOOLTIP: 'Koliko časa je trajalo ustvarjanje tega odgovora',
    CHAT_STATS_ACTIONS_TOOLTIP: 'Koliko dejanj je agent izvedel (nalaganje veščin, izvajanje kode)',
    CHAT_STATS_CONTEXT_TOOLTIP: 'Trenutna velikost konteksta pogovora. Starejši deli pogovora se povzamejo, ko ta postane prevelik.',
    CHAT_DEFAULT_TITLE: 'Klepet',
    CHAT_ENTER_FULLSCREEN: 'Celozaslonski način',
    CHAT_EXIT_FULLSCREEN: 'Zapusti celozaslonski način',
    CHAT_RENAME: 'Preimenuj klepet',
    CHAT_DELETE: 'Izbriši klepet',
    CHAT_CREATE_NEW: 'Ustvari nov klepet',
    CHAT_MESSAGE_PLACEHOLDER: 'Sporočilo za FarseerAI...',
    CHAT_SEND: 'Pošlji',
    CHAT_RENAME_TITLE: 'Preimenuj klepet',
    CHAT_HELP_QUESTION: 'Kako vam lahko danes pomagam',
    CHAT_SUGGESTED: 'Predlagano',
    CHAT_GENERATING_SUGGESTIONS: 'Prilagajanje predlogov vašemu modelu…',
    CHAT_SUGGESTED_SUMMARY: 'Podaj mi kratek povzetek modela',
    CHAT_SUGGESTED_VARIANCE: 'Kakšno je največje odstopanje med dejanskimi rezultati in planom letos ter zakaj?',
    CHAT_SUGGESTED_DRIVERS: 'Razčleni, kaj poganja moje rezultate v tem četrtletju',
    CHAT_SUGGESTED_DASHBOARD: 'Ustvari Nadzorno ploščo z vodstvenim pregledom za ta model',
    CHAT_SUGGESTED_PNL_DASHBOARD: 'Ustvari P&L Nadzorno ploščo s primerjavo dejanskih rezultatov in plana',
    CHAT_SUGGESTED_APPS: 'Kaj lahko zaženem od tukaj? Pokaži moje razpoložljive aplikacije',
    CHAT_SUGGESTED_RANKING: 'Pokaži mi moje najboljše in najslabše rezultate letos',
    CHAT_CREATED: 'Klepet ustvarjen!',
    CHAT_CREATED_NEW: 'Nov klepet ustvarjen!',
    CHAT_RENAMED: 'Klepet preimenovan!',
    CHAT_DELETED: 'Klepet izbrisan!',
    CHAT_FAILED_CREATE: 'Ustvarjanje novega klepeta ni uspelo.',
    CHAT_FAILED_LOAD: 'Nalaganje klepetov ni uspelo.',
    CHAT_FAILED_RENAME: 'Preimenovanje klepeta ni uspelo.',
    CHAT_FAILED_DELETE: 'Brisanje klepeta ni uspelo.',
    CHAT_FAILED_CANCEL: 'Preklic zahteve ni uspel.',
    CHAT_FEEDBACK_FAILED: 'Povratnih informacij ni bilo mogoče shraniti.',
    CHAT_FEEDBACK_THUMBS_UP: 'Dober odgovor',
    CHAT_FEEDBACK_THUMBS_DOWN: 'Slab odgovor',
    CHAT_FEEDBACK_COMMENT_TITLE: 'Povejte nam, kaj je šlo narobe',
    CHAT_FEEDBACK_COMMENT_PLACEHOLDER: 'Kaj je bilo koristno ali kaj je šlo narobe? (neobvezno)',
    CHAT_FEEDBACK_COMMENT_SAVE: 'Shrani',
    CHAT_FEEDBACK_CLEAR: 'Počisti povratne informacije',
    CHAT_AGENT_TYPE_ANALYST: 'Analitik',
    ADVANCED_SETTINGS: 'Napredne nastavitve',
    INVALID_JSON_ERROR: 'Neveljaven JSON: {message}',
    MAINTENANCE_MODE_CURRENTLY_ENABLED: 'Način vzdrževanja je trenutno omogočen',
    MAINTENANCE_MODE_ENABLED: 'Način vzdrževanja omogočen',
    CONTACT_ADMIN_FOR_INFO: 'Prosimo, počakajte ali se obrnite na skrbnika za več informacij.',
    RETRY: 'Poskusi znova',
    OTHER_WORKSPACES_AVAILABLE: 'Preklopite na delovni prostor, do katerega imate dostop:',
    COPY_LINK: 'Kopiraj povezavo',
    COPY_DATA_FROM: 'Kopiraj podatke iz',
    ROWS_CUT: 'Vrstice izrezane',
    ROWS_COPIED: 'Vrstice kopirane',
    ROWS_MOVED: 'Vrstice premaknjene',
    ROWS_PASTED: 'Vrstice prilepljene',
    CELLS_CUT: 'Celice izrezane',
    CELLS_COPIED: 'Celice kopirane',
    CELLS_COPIED_FROM: 'Celice, kopirane iz "{label}"',
    FAILED_CELLS_COPIED: 'Kopiranje celic ni uspelo {message}',
    CANNOT_CELLS_PASTED: 'Sem ni mogoče prilepiti celic',
    NAMED_COPY: '{name} (kopija)',
    TAG: 'Oznaka',
    ACTION: 'Dejanje',
    MANAGE_CONNECTIONS_FOR: 'Upravljaj povezave za',
    RENAME: 'Preimenuj',
    RENAME_FILE_EXTENSION_REQUIRED: 'Imena datotek potrebujejo pripono, na primer .csv ali .xlsx.',
    RENAME_FILE_EXTENSION_CHANGE_TITLE: 'Spremeni pripono datoteke?',
    RENAME_FILE_EXTENSION_CHANGE_QUESTION: 'S tem se pripona spremeni iz “.{oldExt}” v “.{newExt}”, kar lahko spremeni način odpiranja datoteke. Nadaljuj?',
    REMOVE_COLUMN: 'Odstrani stolpec',
    REMOVE_CONNECTION: 'Odstrani povezavo',
    TABLE_CONNECTION: 'Povezava tabele',
    TEXT: 'Besedilo',
    TEXT_COLUMN: 'Besedilni stolpec',
    NUMBER: 'Število',
    NUMBER_COLUMN: 'Številski stolpec',
    NEW_NUMBER_COLUMN: 'Nov številski stolpec',
    FILE: 'Datoteka',
    FILE_COLUMN: 'Stolpec z datoteko',
    DATE_COLUMN: 'Datumski stolpec',
    EDIT_TAG_TYPE: 'Uredi {tagTypeName}',
    DELETE_TAG_TYPE: 'Izbriši {tagTypeName}',
    DELETE_TAG_TYPE_DATA: 'Izbriši podatke {tagTypeName}',
    CONNECTIONS: 'Povezave',
    EDIT_CONNECTIONS: 'Uredi povezave',
    CLEAR_FIELD: 'Počisti polje',
    ERROR_CLEAR_FIELD: 'Napaka pri čiščenju polja',
    REPLACE_FILE: 'Zamenjaj datoteko',
    DOWNLOAD_FILE: 'Prenesi datoteko',
    DOWNLOAD_ORIGINAL_FILE: 'Prenesi izvirno datoteko',
    FILE_DOES_NOT_EXIST: 'Datoteka ne obstaja',
    DELETE_FILE: 'Izbriši datoteko',
    ERROR_DELETE_FILE: 'Napaka pri brisanju datoteke',
    LOCKS: 'Zaklepanja',
    YEARS_VERSIONS_MONTHS: 'Leta / Različice / Meseci',
    CUSTOM_LOCK_RULES: 'Pravila zaklepanja po meri',
    STANDARD_LOCK_RULES: 'Standardna pravila zaklepanja',
    LOCK_RULES_WILL_BE_CONVERTED_TO_STANDARD: '{{1 pravilo zaklepanja|?? pravila zaklepanja}} bo uporabljenih za tabelo Leta / Različice / Meseci',
    LOCK_WILL_BE_CONVERTED_TO_STANDARD: 'To pravilo zaklepanja bo uporabljeno za zgornjo tabelo Leta / Različice / Meseci.',
    NO_CUSTOM_LOCKS_DEFINED: 'Ni določenih pravil zaklepanja po meri',
    LOCK_REFERENCES_DELETED_ENTITIES: 'Ta zaklep se sklicuje na izbrisane entitete',
    TABLE_SETTINGS: 'Nastavitve tabele',
    NEW_MEMBER: 'Nov član',
    SORT_TABLE: 'Razvrsti tabelo',
    LOCK_TABLE: 'Zakleni tabelo',
    UNLOCK_TABLE: 'Odkleni tabelo',
    TABLE_LOCKED_TOOLTIP: 'Ta tabela je zaklenjena',
    UNLOCK_SYSTEM_TABLE_TITLE: 'Odkleni sistemsko tabelo',
    UNLOCK_SYSTEM_TABLE_WARNING: 'To je sistemska tabela. Odklepanje lahko vpliva na celovitost modela. Ali ste prepričani, da jo želite odkleniti?',
    ERROR_LOCKING_TABLE: 'Napaka pri zaklepanju tabele.',
    ERROR_UNLOCKING_TABLE: 'Napaka pri odklepanju tabele.',
    NAME_ASCENDING: 'Ime naraščajoče',
    NAME_DESCENDING: 'Ime padajoče',
    ADD_SORT_RULE: 'Dodaj pravilo razvrščanja',
    REMOVE_ALL_SORT_RULES: 'Odstrani vsa pravila razvrščanja',
    '1_SORT': '1 razvrščanje',
    N_SORTS: '{count} razvrščanj',
    DESCRIPTION_ASCENDING: 'Opis naraščajoče',
    DESCRIPTION_DESCENDING: 'Opis padajoče',
    SORTING_DIMENSIONS: 'Razvrščanje dimenzij...',
    DIMENSIONS_SORTED: 'Dimenzije razvrščene!',
    ERROR_SORTING_DIMENSIONS: 'Napaka pri razvrščanju dimenzij.',
    EDITING_TIMELINE_SLICER: 'Urejanje časovnega rezalnika {title}',
    CREATE_NEW_TIMELINE_SLICER: 'Ustvari nov časovni rezalnik',
    INTERVAL_START: 'Začetek intervala',
    INTERVAL_END: 'Konec intervala',
    FORMAT: 'Oblika',
    OPERATION: 'Operacija',
    MY_PROFILE_INFORMATION: 'Moji profilni podatki',
    PROFILE_SETTINGS: 'Nastavitve profila',
    ADD_PHOTO: 'Dodaj fotografijo',
    CHANGE_PHOTO: 'Spremeni fotografijo',
    UPDATE_PHOTO: 'Posodobi fotografijo',
    REMOVE_PHOTO: 'Odstrani fotografijo',
    DECIMAL_SEPARATOR: 'Decimalni ločilnik',
    DATE_FORMAT: 'Oblika datuma',
    DATE_SEPARATOR: 'Ločilnik datuma',
    ACCESSIBLE_CHART_PATTERNS: 'Vzorci dostopnosti za grafikone',
    SET_AS_DEFAULT_PALETTE: 'Nastavi kot privzeto paleto',
    SAVE_CURRENT_COLORS_AS_PALETTE: 'Shrani trenutne barve kot paleto',
    DELETE_PALETTE: 'Izbriši paleto',
    FILL_STYLE: 'Slog polnila',
    SOLID: 'Polno',
    HATCHED: 'Šrafirano',
    VARIABLE: 'Spremenljivka',
    DIMENSION: 'Dimenzija',
    CREATE_OR_GENERATE_NEW_ROWS: 'Ustvari ali generiraj nove vrstice',
    CREATE_ROW_AS: 'Ustvari {row} kot',
    GENERATE_ROWS_FROM: 'Generiraj vrstice iz',
    CREATE_NEW_VARIABLE: 'Ustvari novo spremenljivko',
    ENTER_FORMULA_FOR: 'Vnesite formulo za {variableName}',
    SELECT_A_VARIABLE_FORMULA: 'Izberite spremenljivko za ogled ali urejanje njene formule',
    DATABASE_AND_PROPERTIES: 'Objekti baze podatkov in lastnosti',
    FOLDER_EMPTY: 'Mapa je prazna',
    DASHBOARD_EMPTY: 'Nadzorna plošča je prazna',
    DASHBOARD_HINT: 'Začnite z nadzorno ploščo tako, da ustvarite ploščico.',
    YEARS_SETTINGS: 'Nastavitve let',
    FINANCIAL_YEAR_STARTING_MONTH: 'Začetni mesec poslovnega leta',
    UPDATING_FINANCIAL_YEAR_STARTING_MONTH: 'Posodabljanje začetnega meseca poslovnega leta',
    FINANCIAL_YEAR_STARTING_MONTH_UPDATED: 'Začetni mesec poslovnega leta posodobljen',
    SOMETHING_WENT_WRONG: 'Nekaj je šlo narobe.',
    SEARCH_FOR_USERS: 'Išči uporabnike...',
    SEARCH_FOR_GROUPS: 'Išči skupine...',
    SEARCH_BY_GROUP_OR_USER: 'Išči po skupini ali uporabniku',
    USERS: 'Uporabniki',
    GROUPS: 'Skupine',
    USER_OR_GROUP: 'Uporabnik/skupina',
    PERMISSIONS: 'Dovoljenja',
    END_DATE_MUST_BE_GREATER_THAN_START_DATE: 'Končni datum mora biti večji od začetnega datuma',
    HISTORY_DATA_CANNOT_OVERLAP_WITH_FORECAST_DATA: 'Zgodovinski podatki se ne smejo prekrivati z napovednimi podatki',
    PLEASE_CHOOSE_AN_ACCOUNT_TAG: 'Prosimo, izberite oznako računa',
    ERROR_STARTING_FORECAST: 'Napaka pri zagonu napovedi',
    CUSTOM_FORECAST: 'Prilagojena napoved',
    HISTORICAL_DATA_FROM: 'Zgodovinski podatki od',
    HISTORICAL_DATA_TO: 'Zgodovinski podatki do',
    SOURCE_VARIABLE_AND_DIMENSIONS: 'Izvorna spremenljivka in dimenzije',
    ERROR: 'Napaka {message}',
    FORECAST: 'Napoved',
    VIEW_FORECASTS_FOR_PERIOD: 'Ogled napovedi za obdobje',
    NO_JOBS_FOR_SELECTED_PERIOD: 'Ni opravil za izbrano obdobje',
    ACTIVE_JOBS: 'Aktivna opravila',
    FINISHED_JOBS: 'Končana opravila',
    COMPLETED_ON: 'Končano {time}',
    FORECAST_PROGRESS: 'Napredek napovedi in zgodovina',
    ERROR_LOADING_FORECAST_JOBS: 'Napaka pri nalaganju napovednih opravil.',
    PAGE: 'Stran',
    EDIT_ENTRY: 'Uredi vnos',
    NEW_ENTRY_BY_DATE: 'Nov vnos po datumu',
    TAGS: 'Oznake',
    ADD_TAG: 'Dodaj oznako',
    START_YEAR: 'Začetno leto',
    START_MONTH: 'Začetni mesec',
    END_YEAR: 'Končno leto',
    END_MONTH: 'Končni mesec',
    MUST_SELECT_ROW: 'Morate izbrati vrstico',
    TITLE: 'Naslov',
    SUBTITLE: 'Podnaslov',
    FOOTNOTES: 'Opombe',
    ROW: 'Vrstica',
    SELECT_ROW: 'Izberite vrstico',
    COLUMN: 'Stolpec',
    ROW_NAME_DISPLAY: 'Prikaz imena vrstice',
    BOTH: 'Oba',
    SHARED_COLUMN_CONFIG_PRESET: 'Deljeni prednastavljen stolpec',
    SHOW_ZERO_SUM_ROWS: 'Prikaži vrstice z ničelno vsoto',
    USE_DATA_FROM_TIMELINE_SLICER: 'Uporabi podatke iz časovnega rezalnika',
    USE_DATA_FROM_DIMENSION_SLICER: 'Uporabi podatke iz dimenzijskega rezalnika',
    DELETE_TARGET_AND_RELATED_DATA: 'in povezane podatke?',
    DELETE_TARGET_CHILDREN: 'Izbriši potomce',
    DELETE_TARGET_DATA: 'Izbriši podatke za',
    CONFIRM_DELETE_ROW: 'Izbriši vrstico?',
    CONFIRM_DELETE_ROWS: 'Izbriši {count} vrstic?',
    CONFIRM_DELETE_ROWS_GENERATED: 'Izbriši generirane vrstice?',
    CONFIRM_DELETE_ROWS_MIXED: 'Izbriši vrstice in generirane vrstice?',
    EXPLAIN_DELETE_ROW: 'To bo izbrisalo <>{row}<>',
    EXPLAIN_DELETE_ROWS_GENERATED: 'To bo izbrisalo generirane vrstice iz <>{table}<> iz te preglednice.',
    EXPLAIN_DELETE_ROWS_MIXED: 'To bo izbrisalo <>{count} vrstic<> in generirane vrstice iz <>{table}<> iz te preglednice.',
    EXPLAIN_DELETE_ROWS_SUBROWS: 'To bo izbrisalo tudi vse podvrstice. Tega dejanja ni mogoče razveljaviti.',
    FAILED_DELETE_ROW: 'Brisanje vrstice ni uspelo',
    DELETE_ROW_AND_ITS_CHILDREN_CONFIRMATION: 'in vse njene podvrstice in elemente?',
    NO_ACCESS_TO_DELETE_ROWS: 'Nimate dostopa do sklicevanih vrstic, zato jih ne morete izbrisati.',
    CREATE_GROUP: 'Ustvari skupino',
    EDIT_PERMISSIONS: 'Uredi dovoljenja',
    USERS_AND_GROUPS_MANAGEMENT: 'Upravljanje uporabnikov in skupin',
    SUM: 'Vsota',
    COUNT: 'Število',
    AVERAGE: 'Povprečje',
    CLOSING_STATE: 'Končno stanje',
    BEGINNING_STATE: 'Začetno stanje',
    FORMULA: 'Formula',
    MAX: 'Maks',
    MIN: 'Min',
    YES: 'Da',
    NO: 'Ne',
    YESTERDAY: 'Včeraj',
    CONFIRM_VARIABLE_REMOVE: 'Potrdite odstranitev spremenljivke',
    CONFIRM_VARIABLES_REMOVE: 'Potrdite odstranitev spremenljivk',
    REMOVE_VARIABLE_CONFIRMATION: 'Ali ste prepričani, da želite odstraniti spremenljivko',
    REMOVE_VARIABLES_CONFIRMATION: 'Ali ste prepričani, da želite odstraniti spremenljivke:',
    REMOVE_VARIABLES_COUNT_CONFIRMATION: 'Ali ste prepričani, da želite odstraniti {tagNumber} spremenljivk?',
    EDIT_VARIABLE: 'Uredi spremenljivko',
    SHARE_VARIABLE: 'Deli spremenljivko',
    DELETE_VARIABLE_DATA: 'Izbriši podatke spremenljivke',
    DELETE_VARIABLE: 'Izbriši spremenljivko',
    EXPAND_MORE: 'Razširi več',
    COLLAPSE_ALL: 'Strni vse',
    SCROLL_TO_BOTTOM: 'Pomakni se na dno',
    VARIABLE_METRICS: 'Meritve spremenljivke',
    VARIABLE_TABLE_COLUMNS: {
        Name: 'Ime',
        Description: 'Opis',
        Formula: 'Formula',
        Dimensions: 'Dimenzije',
        'Read-only': 'Samo za branje',
        'Roll-up type': 'Vrsta združevanja',
    },
    LOADING_DATA: 'Nalaganje podatkov…',
    SUCCESSFULLY_LOADED_DATA: 'Podatki naloženi',
    LOADING_DATA_FAILED: 'Podatkov ni mogoče naložiti',
    LOADING_DATA_FAILED_SUBTITLE: 'Poskusite osvežiti stran',
    WAITING: 'Čakanje...',
    VIEW_LOGS: 'Prikaži dnevnik',
    LOADING_DATA_LOG: 'Dnevnik nalaganja podatkov',
    CALCULATION_STARTED: 'Izračun se je začel.',
    CALCULATION_FINISHED: 'Izračun je končan.',
    DATABASE_LOADED: 'Baza podatkov naložena. Število naloženih celic: {numberOfCells}',
    VARIABLE_CALCULATION_STARTED: 'Izračun spremenljivke {variableName} se je začel. Število vhodnih celic: {numberOfCells}',
    VARIABLE_CALCULATION_ENDED: 'Izračun spremenljivke {variableName} končan. Število celic: {numberOfCells}, faktor izh/vh: {outInFactor}.',
    NEW_ROW: 'Nova vrstica',
    NEW_TEMPLATE_OR_ROW: 'Novo',
    ADD_TEMPLATE_TO_TOOLBAR: 'Dodaj v orodno vrstico',
    REMOVE_TEMPLATE_FROM_TOOLBAR: 'Odstrani iz orodne vrstice',
    IN_TOOLBAR: 'V orodni vrstici',
    TEMPLATE_ADDED_TO_TOOLBAR: 'Predloga dodana v orodno vrstico',
    TEMPLATES: 'Predloge',
    SELECT_A_ROW: 'Izberite vrstico',
    FILE_CANT_BE_PREVIEWED: 'Datoteke ni mogoče predogledati',
    THIS_TYPE_OF: 'Ta vrsta',
    INPUT_SETUP: 'Nastavitev vnosa',
    ONDEMAND_CALCULATION: 'Izračun na zahtevo',
    REFRESH_DATA: 'Osveži podatke',
    DISABLE_MAINTENANCE_MODE: 'Onemogoči način vzdrževanja',
    ENABLE_MAINTENANCE_MODE: 'Omogoči način vzdrževanja',
    SAVED: 'Shranjeno',
    FORMULA_ERROR: 'Napaka v formuli',
    UNEXPECTED: 'Nepričakovano',
    INVALID_SYNTAX: 'Neveljavna skladnja za',
    MISSING_TOKEN_AFTER: 'Manjkajoči žeton po',
    UNNECESSARY: 'Nepotrebno',
    ERROR_MESSAGE_OCCURRED: 'Prišlo je do napake',
    INCOMPLETE_sheet_ITEM_DATA: 'Nepopolni podatki elementa preglednice',
    FAIL_SAVE_sheet_ITEMS: 'Shranjevanje elementov preglednice ni uspelo',
    HEADER_COLUMNS: {
        Description: 'Opis',
        Date: 'Datum',
        Version: 'Različica',
        'Variable and Dimensions': 'Spremenljivka in dimenzije',
        Value: 'Vrednost',
        'Value type': 'Vrsta vrednosti',
        Action: 'Dejanje',
    },
    DESCRIPTION_UPDATE_DATE_TAGS_FAILED: 'Posodobitev opisov za mesečne in letne oznake ni uspela.',
    COMPARISON: 'Primerjava',
    DISALLOW: 'Onemogoči',
    USE_DEFAULT: 'Uporabi privzeto',
    SKIP_ROW: 'Preskoči vrstico',
    MISSING_MEMBERS_IMPORT_NOT_ALLOWED: 'Uvoz ne bo dovoljen, dokler so prisotni manjkajoči člani.',
    MISSING_MEMBERS_SKIP_ROWS: 'Vrstice z manjkajočimi člani bodo preskočene.',
    MISSING_MEMBERS_DEFAULT: 'Podatki manjkajočih članov bodo uvoženi v privzetega člana tabele.',
    CONFIGURE_JOB_OPTIONS: 'Nastavi možnosti opravila',
    HANDLE_MISSING_DIMENSION_MEMBERS: 'Obravnava manjkajočih članov dimenzij',
    IMPORT_ZEROS: 'Uvozi ničle',
    OVERWRITE_CELLS: 'Prepiši celice',
    IGNORE_FINANCIAL_YEAR_OFFSET: 'Ignoriraj odmik poslovnega leta',
    SKIP_EMPTY_ROWS: 'Preskoči prazne vrstice',
    SKIP_REPEATING_HEADER_ROWS: 'Preskoči ponavljajoče se vrstice glave tabele',
    SKIP_LOW_SIGNAL_ROWS_HEURISTIC: 'Preskoči vrstice z nizko informativnostjo (hevristika)',
    ROWS_WILL_BE_SKIPPED_ON_IMPORT: 'Pri uvozu bo preskočenih {count} vrstic/-e/-a.',
    NO_ROWS_WILL_BE_SKIPPED_ON_IMPORT: 'Pri uvozu ne bo preskočena nobena vrstica.',
    INCLUDE_IN_IMPORT: 'Vključi v uvoz',
    EXCLUDE_FROM_IMPORT: 'Izključi iz uvoza',
    MISSING_MEMBERS_REPLACE_ALL: 'Zamenjaj vse prejšnje člane dimenzij',
    MISSING_MEMBERS_REPLACE_ALL_CONFIRMATION: 'Ali ste prepričani, da želite zamenjati vse prejšnje člane dimenzij?',
    APPLY_MEMBERS_AND_VARIABLES_TO_VALUE_COLUMNS: 'Uporabi člane in spremenljivke na vrednostnih stolpcih',
    WRONG_RESULT_TYPE_FOR_COLUMN: 'Napačna vrsta rezultata za stolpec {columnKey}',
    TRIED_TO_ADD_NON_UNIQUE_TAGS: 'Poskus dodajanja needinih oznak',
    TRIED_TO_CREATE_TAG_WITH_EMPTY_NAME: 'Poskus ustvarjanja oznake s praznim imenom',
    NO_PARENT_TAG_SELECTED: 'Nobena nadrejena oznaka ni izbrana',
    COLUMN_MANAGER: 'Stolpci',
    NO_COLUMNS: 'Ni stolpcev.',
    NEW_COLUMN_TIP: 'Začnete lahko z dodajanjem novega elementa stolpca. Od tam uporabite stransko vrstico za izbiro in ustvarjanje prilagojenih stolpcev.',
    NEW_COLUMN: 'Nov stolpec',
    COLUMN_TO_NUMBER_TYPE: 'Spremeni v število',
    COLUMN_TO_COMPARISON_TYPE: 'Spremeni v primerjavo',
    COMPARISON_OPERATION: 'Operacija',
    DROP_ELEMENTS: 'Spustite elemente...',
    READONLY: 'Samo za branje',
    CUSTOM_TITLE: 'Prilagojen naslov',
    SELECT_ROW_TO_DROP_ELEMENTS: 'Izberite vrstico za spust elementov.',
    CANT_MOVE_ROW_INSIDE_SELF: 'Vrstice ni mogoče premakniti vase.',
    CLEAR_ALL: 'Počisti vse',
    MIGRATE_TO_SHEET: 'Preseli v preglednico',
    CHOOSE_TIME_PERIOD: 'Prosimo, izberite časovno obdobje',
    NO_VARIABLE: 'Brez spremenljivke',
    NO_ROWS_SELECTED: 'Nobena vrstica ni izbrana',
    STARTING_YEAR_NOT_ACTIVE: 'Začetno leto ni aktivno',
    SHEET: 'Preglednica',
    ASSIGNEE: 'Dodeljenec',
    APPROVER: 'Odobritelj',
    SHARED_TO: 'Deljeno z',
    PUBLIC: 'Javno',
    PUBLIC_LINK: 'Javna povezava',
    VERSIONS_AND_INTERVAL: 'Različice in interval',
    INTERVAL: 'Interval',
    EXPIRES_IN: 'Poteče čez',
    STATUS: 'Status',
    STATUS_EXPIRES_IN: 'Status (poteče čez)',
    PUBLIC_ASSIGNMENT_LINK_COPIED_TO_CLIPBOARD: 'Javna povezava naloge kopirana v odložišče',
    EXPORTING: 'Izvažanje...',
    APPROVE: 'Odobri',
    DISAPPROVE: 'Zavrni',
    EXPORT: 'Izvozi',
    EXPIRE: 'Poteče',
    REFRESH: 'Osveži',
    NO_ASSIGNMENTS_AVAILABLE: 'Ni razpoložljivih nalog.',
    MARK_IN_REVIEW: 'Označi kot v pregledu',
    MARK_AS_UNRESOLVED: 'Označi kot nerešeno',
    MARK_AS_RESOLVED: 'Označi kot rešeno',
    GO_TO_ROW: 'Pojdi na vrstico',
    DELETE_THREAD: 'Izbriši nit',
    REPLAY_OR_TAG_IN_COMMENT: 'Odgovorite ali označite druge z @...',
    COMMENT_OF: 'Komentar {arrowsCurrent} od {arrowsAll}',
    COMMENT: 'Komentar',
    COMMENTS: 'Komentarji',
    LOADING_IMPORT_JOBS: 'Nalaganje uvoznih opravil',
    IMPORT_ROWS_TRUNCATED_WARNING: 'Nabor podatkov je prevelik za popoln prikaz. Prikazanih je samo prvih 200.000 vrstic. Vse vrstice bodo še vedno uvožene ob potrditvi.',
    SELECTED_JOB_DOESNT_EXIST: 'Izbrano opravilo ne obstaja',
    GO_BACK_TO_IMPORT: 'Pojdi nazaj na uvoz',
    BACK_TO_IMPORT: 'Nazaj na uvoz',
    AT_LEAST_ONE_CHART_LINE: 'Dodati morate vsaj eno črtno grafiko.',
    AT_LEAST_ONE_X_AXIS_TAG: 'Dodati morate vsaj eno oznako osi x',
    VISUALIZATION_TYPE: 'Vrsta vizualizacije',
    VISUALISATION_OPTIONS: 'Možnosti vizualizacije',
    EDIT_CHART: 'Urejanje grafikona "{title}"',
    BAR_CHART: 'Stolpični grafikon',
    BAR: 'Stolpec',
    STACKED_BAR_CHART: 'Naloženi stolpični grafikon',
    STACKED_BAR: 'Naloženi stolpec',
    WATERFALL_CHART: 'Slapovni grafikon',
    WATERFALL: 'Slap',
    PIN_CHART: 'Igelni grafikon',
    PIN: 'Igla',
    AREA_CHART: 'Območni grafikon',
    AREA: 'Območje',
    STACKED_AREA_CHART: 'Naloženi območni grafikon',
    STACKED_AREA: 'Naloženo območje',
    LINE_CHART: 'Črtni grafikon',
    LINE: 'Črta',
    COMBO_CHART: 'Kombinirani grafikon',
    PIE_CHART: 'Tortni grafikon',
    TRAFFIC_LIGHT: 'Semafor',
    INDICATOR: 'Indikator',
    SINGLE_VALUE: 'Posamezna vrednost',
    CREATE_CHART: 'Ustvari nov grafikon',
    ORIENTATION_LAYOUT: 'Usmeritev in postavitev',
    HORIZONTAL: 'Vodoravno',
    VERTICAL: 'Navpično',
    SINGLE: 'Posamično',
    GRID: 'Mreža',
    THIN: 'Tanko',
    THICK: 'Debelo',
    DOUBLE: 'Dvojno',
    DOT: 'Pika',
    CIRCLE: 'Krog',
    SQUARE: 'Kvadrat',
    CATEGORY_AXIS: 'Os kategorij',
    DOMAIN_AXIS: 'Os domene',
    SHOW_TOTALS: 'Prikaži vsote',
    SHOW_AXIS: 'Prikaži os',
    SHOW_VALUE_AXIS: 'Prikaži vrednostno os',
    SHOW_CATEGORY_AXIS_LABELS: 'Prikaži oznake osi kategorij',
    COMPACT_AXIS_LABELS: 'Strnjene oznake osi',
    CATEGORY_LABEL_ANGLE: 'Kot oznake kategorije',
    LABEL_FORMAT: 'Oblika oznake',
    SHOW_LEGEND: 'Prikaži legendo',
    SHOW_INTEGRATED_LEGEND: 'Prikaži integrirano legendo',
    VALUE_LABELS: 'Oznake vrednosti',
    ROW_VALUE_LABELS: 'Oznake vrednosti vrstic',
    SHOW_VALUE_LABELS: 'Prikaži oznake vrednosti',
    POSITION: 'Položaj',
    SMART_FILTERING: 'Pametno filtriranje',
    TRANSPOSE_DATA: 'Transponiraj vrstice in stolpce',
    NORMALIZE_TO_PERCENT: 'Normaliziraj na 100%',
    SHOW_EMPTY_ROWS: 'Prikaži prazne vrstice',
    SHOW_EMPTY_COLUMNS: 'Prikaži prazne stolpce',
    GROUP_BY_PARENT_ROW: 'Združi po nadrejeni vrstici',
    ACCUMULATE_DATA: 'Izračunaj tekočo vsoto',
    COLOR_BY_VALUE: 'Barva glede na vrednost',
    COLOR_BY_TREND: 'Barva glede na trend',
    COLOR_TOTALS_BY_VALUE: 'Barva vsot glede na vrednost',
    THRESHOLD_VALUE: 'Pragovna vrednost',
    USE_SHARED_SCALE: 'Uporabi deljeno lestvico',
    STATIC: 'Statično',
    BY_VALUE: 'Po vrednosti',
    BY_TREND: 'Po trendu',
    BAR_SPACING: 'Razmik stolpcev',
    GAP: 'Vrzel',
    WIDTH: 'Širina',
    USE_DATA_FROM_DIMENSION_SLICERS: 'Uporabi podatke iz dimenzijskih rezalnikov',
    X_AXIS_DIMENSION_BUILDER: 'Gradnik dimenzije osi X',
    ADD_REMOVE_X_AXIS_COLUMN: 'Dodaj/odstrani stolpec osi X',
    Y_AXIS_ITEMS: 'Elementi osi Y',
    ADD_CHART_LINE: 'Dodaj črtno grafiko',
    UNLOCK_HIERARCHY: 'Odkleni hierarhijo',
    LOCK_HIERARCHY: 'Zakleni hierarhijo',
    MATERIALIZE: 'Materializiraj',
    MORE_OPTIONS: 'Več možnosti',
    LOCK_ROW: 'Zakleni vrstico',
    LOCK_COLUMN: 'Zakleni stolpec',
    PASTE: 'Prilepi',
    COPY: 'Kopiraj',
    CUT: 'Izreži',
    PASTE_ROWS: 'Prilepi vrstico(e)',
    COPY_ROWS: 'Kopiraj vrstico(e)',
    CUT_ROWS: 'Izreži vrstico(e)',
    MOVING_ROWS: 'Premikanje vrstic...',
    PASTING_ROWS: 'Lepljenje vrstic...',
    CONFIRM_LOCK: 'Potrdi zaklepanje',
    CONFIRM_UNLOCK: 'Potrdi odklepanje',
    CONFIRM_LOCK_AND_CHILDREN: 'Ali ste prepričani, da želite zakleniti to vrstico in njene potomce?',
    CONFIRM_UNLOCK_AND_CHILDREN: 'Ali ste prepričani, da želite odkleniti to vrstico in njene potomce?',
    SEARCH_FOR_IMPORTS: 'Išči uvozi',
    NEW_IMPORT: 'Nov uvoz',
    IMPORTER: 'Uvoznik',
    CREATION_DATE: 'Datum ustvarjanja',
    ACTIONS: 'Dejanja',
    ADD_ACTION: 'Dodaj dejanje',
    ADD_ARGUMENT: 'Dodaj argument',
    EDIT_ACTION: 'Uredi dejanje',
    ACTION_NAME: 'Ime dejanja',
    ARCHIVE: 'Arhiviraj',
    REPLACE: 'Zamenjaj',
    STATUS_MESSAGE_MAP: {
        'In progress': 'V teku',
        Commited: 'Potrjeno',
        Archived: 'Arhivirano',
        Reverted: 'Povrnjeno',
    },
    EDIT_TILE: 'Uredi ploščico',
    FOCUS_TILE: 'Fokusiraj ploščico',
    UNFOCUS_TILE: 'Odstrani fokus ploščice',
    MOVE_TO: 'Premakni v',
    ADD_ROW: 'Dodaj vrstico',
    ADD_COLUMN: 'Dodaj stolpec',
    EDIT_ROW: 'Uredi vrstico',
    FROM: 'Od',
    TO: 'Do',
    GLOBAL_FORMATTING: 'Globalno oblikovanje',
    FAIL_SAVE_CHANGES: 'Shranjevanje sprememb ni uspelo.',
    TAG_NAME_EXISTS: 'Ime oznake že obstaja.',
    MUST_CHOOSE_TYPE: 'Morate izbrati vrsto',
    MUST_ENTER_TAG_NAME: 'Morate vnesti ime oznake',
    TAG_NAME_CANT_CONTAIN_QUOTATION_MARKS: 'Ime oznake ne sme vsebovati narekovajev.',
    INVALID_VARIABLE_TAG_FORMAT: 'Neveljavna oblika oznake spremenljivke: {tagFormat}',
    INVALID_FORMULA: 'Neveljavna formula.',
    FUNCITON_NOT_ALLOWED_ON_DIMENSION_TAGS: 'Funkcija {image} ni dovoljena na oznakah dimenzij.',
    CREATE_DATABASE_OBJECT: 'Ustvari objekt baze podatkov',
    EDIT_TAG_TYPE_NAME: 'Uredi {tagType} "{tagName}"',
    PARENT: 'Nadrejeni',
    ROOT: 'Koren',
    SEARCH_OR_SELECT_PARENT_TAG: 'Išči ali izberi nadrejeno oznako',
    ROLLUP_TYPE: 'Vrsta združevanja',
    DATA_TYPE: 'Vrsta podatkov',
    FORMAT_TYPE: 'Vrsta oblike',
    CHOOSE_FORMATTING_OPTION: 'Izberite možnost oblikovanja',
    ENTER_CUSTOM_FORMAT: 'Vnesite prilagojeno obliko',
    CUSTOM_FORMAT: 'Prilagojena oblika',
    TOP_DOWN: 'Od zgoraj navzdol',
    TOP_DOWN_DATA_MAPPING: 'Preslikava podatkov od zgoraj navzdol',
    CONNECTED: 'Povezano',
    ADD_CONNECTED_VARIABLE: 'Dodaj povezano spremenljivko',
    REVERSE_CONNECTED: 'Obratno povezano',
    ADD_REVERSE_CONNECTED_VARIABLE: 'Dodaj obratno povezano spremenljivko',
    DIMENSIONS: 'Dimenzije',
    ADD_DIMENSION: 'Dodaj dimenzijo',
    ADVANCED: 'Napredno',
    CALCULATE_ON_DEMAND: 'Izračunaj na zahtevo',
    TRIGGER_ON_DEMAND_CALCULATION: 'Za sprožitev izračuna na zahtevo pojdite na "Nastavitev vnosa"',
    OPTIMIZE_CALCULATION: 'Optimiziraj izračun',
    CONSTRAINED_LIGHT_TOP_DOWN: 'Omejeni lahki od zgoraj navzdol',
    USE_HIERARCHY_IN_CALCULATION: 'Uporabi hierarhijo pri izračunu',
    MAPPING_TO_VARIABLE: 'Preslikava v spremenljivko',
    ADD_FROM_VERSION: 'Dodaj iz različice',
    MAPPING_FROM_VERSION: 'Preslikava iz različice',
    MAPPING_TO_VERSION: 'Preslikava v različico',
    ADD_TO_VERSION: 'Dodaj v različico',
    USED_IN_FORMULA: 'Uporabljeno v 1 formuli',
    USED_IN_FORMULAS: 'Uporabljeno v {numberOfTags} formulah',
    TABLE_BACKLINKS: 'Sklicevano iz {{1 tabele|?? tabel}}',
    VARIABLE_BACKLINKS: 'Uporabljeno v {{1 spremenljivki|?? spremenljivkah}}',
    ACTIVE: 'Aktivno',
    CONNECTED_DIMENSION: 'povezana dimenzija',
    MY_ACCOUNT: 'Moj račun',
    SIGN_OUT: 'Odjava',
    LOG_OUT: 'Odjava',
    EDIT_PROFILE: 'Uredi profil',
    FARSEER_AI: 'FarseerAI',
    FARSEER_LABS: 'Farseer Labs',
    DATA_HUB: 'Data Hub',
    DATASETS: 'Nabori podatkov',
    PIPELINES: 'Procesi',
    NAMESPACE: 'Imenski prostor',
    SEARCH_FOR_DATASETS: 'Išči nabore podatkov',
    NO_DATASETS_YET: 'Naborov podatkov še ni. Nabori podatkov se ustvarijo, ko se procesi zaženejo s shranjevanjem naborov podatkov.',
    SEARCH_FOR_PIPELINES: 'Išči procese',
    NO_PIPELINES_YET: 'Procesov še ni. Proces je aplikacija, ki se izvaja na izvajalcu procesov.',
    PROFILE_AND_SUPPORT: 'Profil in podpora',
    RENAME_TABLE: 'Preimenuj tabelo',
    SHARE_TABLE: 'Deli tabelo',
    DELETE_TABLE_DATA: 'Izbriši podatke tabele',
    DELETE_TABLE_MEMBERS: 'Izbriši člane tabele',
    DELETE_TABLE_DIMENSIONS: 'Izbriši dimenzije tabele',
    DELETE_TABLE: 'Izbriši tabelo',
    DELETE_ROW: 'Izbriši vrstico',
    DELETE_ROWS: 'Izbriši vrstico(e)',
    SHOW_VALUE: 'Prikaži vrednost',
    SHOW_VARIABLES_AND_DIMENSIONS: 'Prikaži spremenljivke in dimenzije',
    FREEZE_PANES: 'Zamrzni podokna',
    FREEZE_UP_TO_THIS_ROW: 'Zamrzni do te vrstice',
    FREEZE_UP_TO_THIS_COLUMN: 'Zamrzni do tega stolpca',
    UNFREEZE_ROWS: 'Odzamrzni vrstice',
    UNFREEZE_COLUMNS: 'Odzamrzni stolpce',
    HIDE_GRIDLINES: 'Skrij mrežne črte',
    HIDE_ROW_COLUMN_HEADERS: 'Skrij glave vrstic/stolpcev',
    LABELS: 'Oznake',
    ADD_LABEL: 'Dodaj oznako',
    ERROR_LABEL_EXISTS: 'Oznaka že obstaja!',
    ERROR_RENAMING_IMPORT_JOB_LABEL: 'Napaka pri preimenovanju oznake uvoznega opravila!',
    IMPORT_JOB_LABEL_RENAMED: 'Oznaka uvoznega opravila preimenovana',
    ERROR_DELETING_IMPORT_JOB_LABEL: 'Napaka pri brisanju oznake uvoznega opravila!',
    IMPORT_JOB_LABEL_DELETED: 'Oznaka uvoznega opravila izbrisana',
    CREATE_OR_SEARCH: 'Ustvari ali išči..',
    CREATE: 'Ustvari',
    NAME_AND_DESCRIPTION: 'Ime in opis',
    SUBTOTALS: 'Vmesne vsote',
    TOTAL: 'Skupaj',
    DISABLED: 'Onemogočeno',
    BEFORE: 'Pred',
    AFTER: 'Po',
    UNSELECT_ALL: 'Prekliči izbiro vseh',
    SAVE_CONFIG_FOR_ALL: 'Shrani konfiguracijo za vse',
    SAVE_CONFIG_FOR_ALL_TOOLTIP: 'Shrani trenutno stanje iskalnika, filtre, časovnico in možnosti preglednice kot privzeto konfiguracijo.',
    EDIT_DIMENSION_SLICER: 'Urejanje dimenzijskega rezalnika "{title}"',
    CREATE_DIMENSION_SLICER: 'Ustvari nov dimenzijski rezalnik',
    ENABLE_MULTISELECT: 'Omogoči večkratno izbiro',
    DISPLAY_MULTIPLE_VALUES: 'Prikaži več vrednosti',
    SEARCH_AND_AUTO_SELECT: 'Iskanje in samodejna izbira',
    BLANKS: '(Prazno)',
    ENTER_TITLE: 'Vnesite naslov...',
    TAG_NAME_DISPLAY: 'Prikaz imena oznake',
    FILTERS: 'Filtri',
    ADD_FILTER: 'Dodaj filter',
    BY_DIMENSION: 'Po dimenziji',
    SHOW_ONLY_DIMENSIONS_WITH_DATA_IN: 'Prikaži samo dimenzije s podatki v...',
    EDIT_SINGLE_VALUE: 'Urejanje posamezne vrednosti "{title}"',
    CREATE_SINGLE_VALUE: 'Ustvari novo posamezno vrednost',
    LEAVE_EMPTY_FOR_AUTOGENERATED: 'Pustite prazno za samodejno generiranje',
    FILTER_DIMENSIONS: 'Filtriraj dimenzije',
    COMPARISON_DIMENSIONS: 'Primerjalne dimenzije',
    COMPARISON_CUSTOM_TEXT: 'Prilagojeno besedilo primerjave',
    DATA_ENTRY: 'Vnos podatkov',
    SHOW_BUTTONS: 'Prikaži gumbe',
    STEP: 'Korak',
    AND: 'in',
    OR: 'ALI',
    DOWNSTREAM_FILTERS: 'Podrejeni filtri',
    TO_TABLE: 'V tabelo',
    FROM_TABLE: 'Iz tabele',
    ADD_DOWNSTREAM_FILTER: 'Dodaj podrejeni filter',
    FLAT: 'Plosko',
    HIERARCHY_MAX_DEPTH: 'Največja globina hierarhije',
    APPLICATION_VERSION: 'Različica aplikacije',
    CONFIRM_TAG_REMOVE: 'Potrdite odstranitev oznake',
    CONFIRM_TAGS_REMOVE: 'Potrdite odstranitev oznak',
    REMOVE_TAG_CONFIRMATION: 'Ali ste prepričani, da želite odstraniti oznako {tagName}?',
    REMOVE_TAGS_CONFIRMATION: 'Ali ste prepričani, da želite odstraniti oznake: {tagNames}?',
    REMOVE_TAGS_NUMBER_CONFIRMATION: 'Ali ste prepričani, da želite odstraniti {tagNumber} oznak?',
    ERROR_PARSING_NUMBER: 'Napaka pri razčlenjevanju števila',
    ERROR_PARSING_DATE: 'Napaka pri razčlenjevanju datuma',
    USE_CONTEXT_MENU_FOR_UPDATING_FILE_COLUMN: 'Prosimo, uporabite kontekstni meni za posodabljanje stolpca z datoteko',
    ERROR_PARSING_INPUT_NUMBER: 'Napaka pri razčlenjevanju vhodnega števila',
    ERROR_SAVING_DATA: 'Napaka pri shranjevanju podatkov',
    DATA_ENTRY_NOT_ALLOWED: 'Vnos podatkov ni dovoljen',
    ERROR_PARSING_STEP_VALUE: 'Napaka pri razčlenjevanju vrednosti koraka',
    TAG_NAME_CELLS: '{tagName}: {cellNumber} celic',
    UNKNOWN_VARIABLE_CELLS: 'Neznana spremenljivka: {cellNumber} celic',
    SUCCESS_IMPORTED_CELLS: 'Uspeh! Uvožene celice: {accountTags}',
    IMPORTED_CELLS: 'Uvožene celice',
    IMPORT_JOB_DELETING: 'Brisanje uvoznega opravila',
    IMPORT_JOB_DELETING_CONFIRM: 'Ali ste prepričani, da želite izbrisati uvozno opravilo {importJobName}?',
    DELETE_AND_KEEP_DATA: 'Izbriši in ohrani podatke',
    DELETE_JOB_AND_DATA: 'Izbriši opravilo in podatke',
    ADD_DIMENSIONS_TO_JOB: 'Dodaj dimenzije opravilu',
    CONFIGURE: 'Nastavi',
    ADD_DESCRIPTION_FOR_IMPORT: 'Dodajte opis za ta uvoz',
    UNDO: 'Razveljavi',
    SETTINGS: 'Nastavitve',
    BASIC_SETTINGS: 'Osnovne nastavitve',
    OTHER_SETTINGS: 'Druge nastavitve',
    TABLE_NAME: 'Ime tabele',
    AUTOGENERATE_DIMENSION_NAMES: 'Samodejno generiraj imena dimenzij',
    AUTOGENERATE_NAMES_CONFIG: 'Konfiguracija samodejnega generiranja imen',
    AUTOGENERATE_NAMES_CONFIG_EXAMPLE: 'npr. {SSS}-{YY}#{DD}',
    CUSTOM_TEMPLATE_DESCRIPTION: 'Določite prilagojeno konfiguracijo za samodejno generiranje imen za to tabelo. Uporabite vnaprej določene žetone spodaj z zavitimi oklepaji. Med žetoni lahko postavite poljuben znak.',
    USE_TOKENS_TO_DEFINE_CONFIG: 'Za določitev konfiguracije lahko uporabite te žetone',
    AUTOGENERATE_CONFIG_EXAMPLE: '{SSS}-{YY}#{MM}_{DD}',
    AUTOGENERATE_CONFIG_EXAMPLE_DATE: '- 001-23#03_20 (20. marec 2023)',
    ENTRY: 'Vnos',
    STEP_MUST_BE_NUMBER: 'Korak mora biti število.',
    EDIT_DATA_EDITOR: 'Urejanje urejevalnika podatkov "{title}"',
    BUTTON_CONTROLS: 'Kontrole gumbov',
    BOLD: 'Krepko',
    ITALIC: 'Ležeče',
    UNDERLINED: 'Podčrtano',
    OUTLINED: 'Orisano',
    FONT_SIZE: 'Velikost pisave',
    FILE_SIZE: 'Velikost datoteke',
    SMALL: 'Majhno',
    MEDIUM: 'Srednje',
    LARGE: 'Veliko',
    CREATE_NEW_COLUMN: 'Ustvari nov stolpec',
    EDIT_COLUMN_WITH_LABEL: 'Uredi stolpec "{label}"',
    COLUMN_TAGS: 'Oznake stolpca',
    DELETE_THIS_COLUMN: 'Izbriši ta stolpec',
    SELECT_PARENT_TAG_TO_GENERATE_COLUMNS: 'Izberite nadrejeno oznako za generiranje več stolpcev',
    USING_SHARED_COLUMN_CONFIG: 'Uporaba deljene konfiguracije stolpca',
    SLICER_GENERATED: 'Rezalnik generiran',
    HEADER_CANNOT_BE_EMPTY: 'Glava ne sme biti prazna',
    MUST_CHOOSE_A_FORMAT: 'Morate izbrati obliko',
    CALCULATION_FIELDS_CANT_BE_EMPTY: 'Polja za izračun ne smejo biti prazna',
    ADD_NEW_COLUMN: 'Dodaj nov stolpec',
    HEADER: 'Glava',
    SUBHEADER: 'Podglava',
    TYPE: 'Vrsta',
    POLARITY: 'Polarnost',
    CONDITIONAL_FORMATTING: 'Pogojno oblikovanje',
    CONDITIONAL_FORMATTING_TYPE_OPTIONS: {
        Relative: 'Relativno',
        Absolute: 'Absolutno',
    },
    CONDITIONAL_FORMATTING_POLARITY_OPTIONS: {
        Positive: 'Pozitivno',
        Negative: 'Negativno',
        Neutral: 'Nevtralno',
    },
    KPI_COLUMN_TYPE_META: {
        Regular: 'Običajno',
        Calculated: 'Izračunano',
    },
    CONDITIONAL_FORMATTING_OPTIONS: {
        Off: 'Izključeno',
        Traffic: 'Semafor',
        Databar: 'Podatkovna vrstica',
        Colorscale: 'Barvna lestvica',
        Arrows: 'Puščice gor in dol',
    },
    HIDE_NUMBERS: 'Skrij številke',
    COLUMN_ONE: 'Stolpec 1',
    COLUMN_TWO: 'Stolpec 2',
    LITERAL: 'literal',
    FUNCTION: 'funkcija',
    FUNCTIONS: 'Funkcije',
    EXAMPLE: 'Primer',
    EDIT_IN: 'Uredi {type}',
    OPEN_IN_EDITOR: 'Odpri v urejevalniku {type}',
    REMOTE_JOBS_DATE_TIME_MESSAGE: 'Vsak teden na {day} ob {time}',
    REMOTE_JOB_SCHEDULED: 'Načrtovano {schedule}',
    SCHEDULE: 'Urnik',
    EVERY: 'Vsak',
    EVERY_HOUR_AT: 'Vsako uro ob',
    EVERY_DAY_AT: 'Vsak dan ob',
    RUN_JOB: 'Zaženi opravilo',
    RUN: 'Zaženi',
    APP_WITH_ID: 'Aplikacija #{id}',
    PIPELINE_RUNS_LOAD_FAILED: 'Zagonov te aplikacije ni bilo mogoče naložiti.',
    PIPELINE_RUN_NOT_FOUND: 'Zagon #{runId} ni v zgodovini zagonov te aplikacije.',
    PIPELINE_SHOW_LATEST_RUN: 'Prikaži najnovejši zagon',
    PIPELINE_OUTPUT: 'Izhod',
    PIPELINE_OUTPUT_IN_FILES: 'Shranjeno v Datotekah. Ta shramba hrani samo najnovejši izhod, ne pa izhoda vsakega zagona.',
    PIPELINE_OUTPUT_STATE_MAP: {
        published: 'Objavljeno s tem zagonom',
        completed: 'Zapisano s tem zagonom, ni objavljeno',
        started: 'Začeto s tem zagonom, ni dokončano',
    },
    PIPELINE_OUTPUT_BEING_WRITTEN: 'Ta zagon ga trenutno zapisuje',
    PIPELINE_OUTPUT_NOT_RECORDED: 'Nabor podatkov z imenom tega koraka obstaja. Ta zagon ni zabeležil njegovega zapisovanja, zato se odpre njegova trenutna različica.',
    PIPELINE_PEEK_TOO_LARGE: 'Ta različica je prevelika za hiter ogled. Odprite to različico za predogled.',
    PIPELINE_PEEK_EMPTY: 'Ta različica nima vrstic.',
    PIPELINE_PEEK_FIRST_ROWS: 'Prvih {shown} od {total} vrstic',
    PIPELINE_PEEK_ALL_ROWS: 'Vseh {total} {{vrstica|vrstice}}',
    PIPELINE_OUTPUT_PAYLOAD: 'Datoteka vira, kot jo je shranil ta zagon, hranjena 30 dni',
    PIPELINE_PAYLOAD_PEEK_TOO_LARGE: 'Ta datoteka je prevelika za hiter ogled. Prenesite jo, da jo odprete.',
    PIPELINE_PAYLOAD_PEEK_EMPTY: 'Ta datoteka nima vrstic.',
    PIPELINE_PAYLOAD_NO_PEEK: 'Datoteke {format} nimajo hitrega ogleda. Korak, ki razčleni to datoteko, prikaže njene podatke.',
    OPEN_IN_FILES: 'Odpri v Datotekah',
    PIPELINE_SELECT_STEP: 'Izberite korak v grafu, da vidite njegove podrobnosti.',
    PIPELINE_WAITING_FOR_STEPS: 'Ta zagon še ni zabeležil nobenega koraka.',
    RUN_LOGS: 'Dnevniki zagona',
    PIPELINE_STEP_NOT_IN_RUN: '{step} ni v tem zagonu.',
    QUEUED: 'V čakalni vrsti',
    RUNNING: 'Izvajanje...',
    UNAVAILABLE: 'Ni na voljo',
    MINUTES: 'minut',
    JOBS: 'Opravila',
    JOB_LOGS: 'Dnevniki opravil',
    PREFERRED_RUNNER: 'Prednostni izvajalec',
    RUNNER_DISCONNECTED: 'Ta izvajalec trenutno ni povezan.',
    RUNNER_IMAGE: 'Slika izvajalca',
    WHERE_RUNS_HAPPEN: 'Kje se izvajanja odvijajo',
    COMPUTE_SHARED_RUNNER: 'Na skupnem izvajalcu',
    COMPUTE_OWN_MACHINE_SIZE: 'Lasten stroj ({size})',
    COMPUTE_OWN_MACHINE_DEFAULT_SIZE: 'Lasten računalnik (privzeta velikost)',
    COMPUTE_WARNING: {
        nothingConnected: 'Noben izvajalec ni povezan, zato ni znano, kje se lahko to opravilo izvede.',
        namedRunnerNotConnected: 'Izvajalec, ki je naveden za to opravilo, ni povezan, zato ni znano, kje se lahko izvede.',
        namedRunnerOffersNoOwnMachine: 'Izvajalec, ki je naveden za to opravilo, ne more ustvariti računalnika, zato se to opravilo ne bo zagnalo.',
        noRunnerOffersOwnMachine: 'Noben povezan izvajalec ne more ustvariti računalnika, zato se to opravilo ne bo zagnalo.',
        namedRunnerOffersNoSharedRun: 'Izvajalec, ki je naveden za to opravilo, izvaja opravila samo na svojem računalniku, zato se to opravilo ne bo zagnalo.',
        noRunnerOffersSharedRun: 'Noben povezan izvajalec ne izvaja opravil na deljenem izvajalcu, zato se to opravilo ne bo zagnalo.',
        namedRunnerOffersNothing: 'Izvajalec, ki je naveden za to opravilo, izvaja opravila samo na svojem računalniku in ga ne more ustvariti, zato se to opravilo ne bo zagnalo.',
        noRunnerOffersAnything: 'Noben povezan izvajalec ne izvaja opravil na deljenem izvajalcu in noben ne more ustvariti računalnika, zato se to opravilo ne bo zagnalo.',
    },
    RUNNER_IMAGE_TAG: 'Različica',
    LOGS: 'Dnevniki',
    REMOTE_JOBS: 'Aplikacije',
    TAG_INTERNAL_TYPE_NAME: {
        Version: 'Različica',
        Year: 'Leto',
        Month: 'Mesec',
        Quarter: 'Četrtletje',
        'Half Year': 'Polletje',
        'Year to Date': 'Od začetka leta',
    },
    VARIABLE_TABLE_DIMENSION_GROUP: 'Spremenljivka/tabela/dimenzija/skupina',
    ADD_NEW_VARIABLE_TABLE_DIMENSION_GROUP: 'Dodaj novo {item}',
    DATA_TYPE_ENUM: {
        Integer: 'Celo število',
        Decimal: 'Decimalno',
    },
    DEFAULT_FORMAT_TYPE_ENUM: {
        Custom: 'Prilagojeno',
        Number: 'Število',
        Currency: 'Valuta',
        Percentage: 'Odstotek',
        Date: 'Datum',
    },
    HEADER_NAVIGATION: {
        Dashboard: 'Nadzorna plošča',
        Sheets: 'Preglednice',
        Import: 'Uvoz',
        'Remote jobs': 'Aplikacije',
        Dimensions: 'Dimenzije',
    },
    ENTITY_TYPE: {
        DIMENSION_TABLE: 'Dimenzijska tabela',
        DIMENSION_MEMBER: 'Član dimenzije',
        VARIABLE: 'Spremenljivka',
        FOLDER: 'Mapa',
        FUNCTION: 'Funkcija',
        LITERAL: 'Literal',
        PROPERTY: 'Lastnost',
        FILE: 'Datoteka',
        DASHBOARD: 'Nadzorna plošča',
        REMOTE_JOB: 'Oddaljeno opravilo',
        SHEET: 'Preglednica',
        TILE: 'Ploščica',
    },
    ENTITY_TYPES: {
        DIMENSION_TABLE: 'Dimenzijske tabele',
        DIMENSION_MEMBER: 'Člani dimenzij',
        VARIABLE: 'Spremenljivke',
        FOLDER: 'Mape',
        FUNCTION: 'Funkcije',
        LITERAL: 'Literali',
        PROPERTY: 'Lastnosti',
        FILE: 'Datoteke',
        DASHBOARD: 'Nadzorne plošče',
        REMOTE_JOB: 'Oddaljena opravila',
        SHEET: 'Preglednice',
        TILE: 'Ploščice',
    },
    ITEM: 'Element',
    ITEM_TYPE: 'Vrsta elementa',
    FOLDER_ITEM: {
        DASHBOARD: 'Nadzorna plošča',
        DIMENSION_TABLE: 'Dimenzijska tabela',
        VARIABLE: 'Spremenljivka',
        SHEET: 'Preglednica',
        FOLDER: 'Mapa',
        FARSEER_FILE: 'Datoteka',
        REMOTE_JOB: 'Aplikacija',
    },
    FOLDER_ITEMS: {
        DASHBOARD: 'Nadzorne plošče',
        DIMENSION_TABLE: 'Dimenzijske tabele',
        VARIABLE: 'Spremenljivke',
        SHEET: 'Preglednice',
        FOLDER: 'Mape',
        FARSEER_FILE: 'Datoteke',
        REMOTE_JOB: 'Aplikacije',
    },
    TABLE_SETTINGS_TEMPLATE_PATTERNS: {
        UUID: 'generira univerzalni edinstveni identifikator',
        YYYY: 'vstavi trenutno leto',
        YY: 'vstavi zadnji dve števki trenutnega leta (kratko leto)',
        MM: 'vstavi trenutni mesec',
        DD: 'vstavi trenutni dan',
        SSSSSSSS: 'vstavi zaporedno številko iz trenutne dolžine potomcev tabele + 1, dolžino določite s številom znakov "S" (1-8)',
    },
    CONFIG_MENU_SECTIONS: {
        'Users & Permissions': 'Uporabniki in dovoljenja',
        'Users & Groups': 'Uporabniki in skupine',
        System: 'Sistem',
        'Input Setup': 'Nastavitev vnosa',
        Locks: 'Zaklepanja',
        'Backup & Restore': 'Varnostno kopiranje in obnovitev',
        'Audit Logs': 'Revizijski dnevniki',
        'Export Model': 'Izvozi model',
        'Import Model': 'Uvozi model',
        'Switch Tenants': 'Zamenjaj delovni prostor',
        Support: 'Podpora',
        'Help Center': 'Center za pomoč',
        'Contact Support': 'Kontaktiraj podporo',
    },
    KPI_COLUMN_OPERATIONS: {
        minus: 'minus',
        divide: 'deli',
        plus: 'plus',
        multiply: 'pomnoži',
        percent: 'odstotek',
        'percent thousands': 'odstotek tisočev',
        'difference in %': 'razlika v %',
    },
    STATUS_MAP: {
        Resolved: 'Rešeno',
        Unresolved: 'Nerešeno',
        'In Review': 'V pregledu',
        QUEUED: 'V ČAKALNI VRSTI',
        RUNNING: 'IZVAJANJE',
        FINISHED: 'KONČANO',
        ERROR: 'NAPAKA',
    },
    USER_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create User': 'Ustvari uporabnika',
        'Delete User': 'Izbriši uporabnika',
        'Find All Users': 'Najdi vse uporabnike',
        'Get User': 'Pridobi uporabnika',
        'Update User': 'Posodobi uporabnika',
    },
    FEATURE_PERMISSIONS_TITLE_MAP: {
        TAGS_IN_MODEL: 'Orodna vrstica vrstic/stolpcev',
        CLUSTER_FLOW_ADD: 'Dodajanje vrstic',
        YEAR_VERSION_LOCKS: 'Zaklepanja',
        IMPORT: 'Uvoz',
        SEE_ALL_IMPORT_JOBS: 'Ogled vseh uvoznih opravil',
        USERS_GROUPS_MANAGEMENT: 'Upravljanje uporabnikov in skupin',
        REMOTE_JOBS: 'Aplikacije',
        COMMENTS: 'Komentarji',
        TAGS_SIDEBAR: 'Stranska vrstica baze podatkov',
        CREDENTIALS: 'Poverilnice',
        INPUT_SETUP: 'Nastavitev vnosa',
        AUDIT_LOGS: 'Ogled revizijskih dnevnikov',
        ASSIGNMENTS: 'Naloge',
        BACKUP_AND_RESTORE: 'Varnostno kopiranje in obnovitev',
        DASHBOARD_TO_IMAGE: 'Nadzorna plošča v sliko',
        CHAT_AI: 'Klepet AI',
        DELETE_DIMENSION: 'Izbriši dimenzijo',
        FORECAST: 'Napoved',
        GOAL_SEEKING_TOP_DOWN: 'Iskanje cilja od zgoraj navzdol',
        MODEL_IMPEX: 'Uvoz/izvoz modela',
        OWD_MEASURES: 'Samo s podatki za mere',
        FORMULA_QA: 'QA formul',
        USE_HIERARCHY_IN_CALCULATION: 'Posodobi "uporabi hierarhijo" v spremenljivkah',
        MODEL_HEALTH: 'Zdravje modela',
        FARSEER_LABS: 'Farseer Labs',
        FARSEER_LOGO: 'Farseer logotip',
        SHARED_WITH_ME: 'Deljeno z mano',
        API_KEY_MANAGEMENT: 'Upravljanje ključev API',
        DATA_HUB: 'Data Hub (bere vse nabore podatkov)',
    },
    CELL_CLASS_PERMISSIONS_TITLE_MAP: {
        'Edit Cells': 'Uredi celice',
    },
    FOLDER_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Folder': 'Ustvari mapo',
        'Duplicate Folder': 'Podvoji mapo',
        'Search Folders': 'Išči mape',
        'Get Items in Folder': 'Pridobi elemente v mapi',
        'Find by Reverse References': 'Najdi po obratnih referencah',
        'Move Items': 'Premakni elemente',
        'Rename Items': 'Preimenuj elemente',
        'Delete Items in Folder': 'Izbriši elemente v mapi',
        'Share Folder Hierarchy': 'Deli hierarhijo map',
    },
    TAG_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Database Object': 'Ustvari objekt baze podatkov',
        'Delete Database Object': 'Izbriši objekt baze podatkov',
        'Get Database Object': 'Pridobi objekt baze podatkov',
        'Update Database Object': 'Posodobi objekt baze podatkov',
        'Search Database Objects': 'Išči objekte baze podatkov',
    },
    SHEET_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Sheet': 'Ustvari preglednico',
        'Get Sheet': 'Pridobi preglednico',
        'Update Sheet': 'Posodobi preglednico',
        'Duplicate Sheet': 'Podvoji preglednico',
        'Search Rows in Sheet': 'Išči vrstice v preglednici',
        'Get Sheet Data': 'Pridobi podatke preglednice',
        'Set Sheet Data': 'Nastavi podatke preglednice',
    },
    SHEET_ROW_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Row': 'Ustvari vrstico',
        'Update Row': 'Posodobi vrstico',
        'Delete Row': 'Izbriši vrstico',
        'Move Row': 'Premakni vrstico',
        'Duplicate Row': 'Podvoji vrstico',
        'Find All Row': 'Najdi vse vrstice',
        'Get Row': 'Pridobi vrstico',
        'Materialize Row': 'Materializiraj vrstico',
    },
    SHEET_LINE_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Line': 'Ustvari linijo preglednice (vrstico ali stolpec)',
        'Update Line': 'Posodobi linijo preglednice',
        'Delete Line': 'Izbriši linijo preglednice',
        'Duplicate Line': 'Podvoji linijo preglednice',
        'Materialize Line': 'Materializiraj linijo preglednice',
        'Get Line': 'Pridobi linijo preglednice',
    },
    SHARE_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Share': 'Ustvari deljenje',
        'Add Public Shares': 'Dodaj javna deljenja',
        'Delete Share': 'Izbriši deljenje',
        'Get Share': 'Pridobi deljenje',
        'Update Share': 'Posodobi deljenje',
    },
    LABEL_CLASS_PERMISSIONS_TITLE_MAP: {
        'Get Label': 'Pridobi oznako',
        'Create Label': 'Ustvari oznako',
        'Update Label': 'Posodobi oznako',
        'Delete Label': 'Izbriši oznako',
    },
    FARSEER_FILE_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create File': 'Ustvari datoteko',
        'Update File': 'Posodobi datoteko',
        'Delete File': 'Izbriši datoteko',
        'Find All Files': 'Najdi vse datoteke',
        'Get File': 'Pridobi datoteko',
    },
    REMOTE_JOB_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Remote Job': 'Ustvari aplikacijo',
        'Update Remote Job': 'Posodobi aplikacijo',
        'Find All Remote Jobs': 'Najdi vse aplikacije',
        'Get Remote Job': 'Pridobi aplikacijo',
        'Run Remote Job': 'Zaženi aplikacijo',
        'Run Remote Job As A Service': 'Zaženi aplikacijo kot storitev',
    },
    OVERSEER_CLASS_PERMISSIONS_TITLE_MAP: {
        'Restore Backup': 'Obnovi varnostno kopijo',
        'Create Backup': 'Ustvari varnostno kopijo',
        'Search Backups': 'Išči varnostne kopije',
        'Download Backup': 'Prenesi varnostno kopijo',
        'Upload Backup': 'Naloži varnostno kopijo',
    },
    MODEL_CLASS_PERMISSIONS_TITLE_MAP: {
        'Read Model': 'Branje modela',
        'Edit Model': 'Urejanje modela',
    },
    SETTING_CLASS_PERMISSIONS_TITLE_MAP: {
        'Update Global Locks': 'Posodobi zaklepanja',
        'Update Financial Year': 'Posodobi začetek finančnega leta',
    },
    DASHBOARD_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Dashboard': 'Ustvari nadzorno ploščo',
        'Duplicate Dashboard': 'Podvoji nadzorno ploščo',
        'Find All Dashboards': 'Najdi vse nadzorne plošče',
        'Get Dashboard': 'Pridobi nadzorno ploščo',
        'Update Dashboard': 'Posodobi nadzorno ploščo',
    },
    FEATURE_PERMISSION_TITLES: {
        FeaturePermission: 'Dovoljenje funkcije',
        FolderClassPermission: 'Dovoljenje razreda map',
        TagClassPermission: 'Dovoljenje razreda oznak',
        SheetClassPermission: 'Dovoljenje razreda preglednic',
        SheetRowClassPermission: 'Dovoljenje razreda vrstic preglednice',
    },
    SEARCH_TAGS: 'Išči oznake...',
    SEARCH_PERMISSIONS: 'Išči dovoljenja...',
    DEFAULT: 'Privzeto',
    FEATURE_PERMISSIONS: 'Dovoljenja funkcij',
    CLASS_PERMISSIONS: 'Dovoljenja razredov',
    ADD_COMMENT: 'Dodaj komentar',
    SORT: 'Razvrsti',
    SORT_BY: 'Razvrsti po',
    ASCENDING: 'Naraščajoče',
    DESCENDING: 'Padajoče',
    UNSORT: 'Odstrani razvrščanje',
    AUTO: 'Auto',
    LEFT: 'Levo',
    ALL_MONTHS: 'Vsi meseci',
    TWELVE_MONTHS: '12 mesecev',
    YEAR_START: 'Začetek leta',
    TIMELINE_START: 'Začetek časovnice',
    COPY_HASH_TAG: 'Kopiraj #',
    SHOW_TOP: 'Prikaži vrh',
    SHOW_REST: 'Prikaži ostalo',
    RIGHT: 'Desno',
    CENTER: 'Sredina',
    TOP: 'Vrh',
    MIDDLE: 'Sredina',
    BOTTOM: 'Dno',
    YEAR_END: 'Konec leta',
    TIMELINE_END: 'Konec časovnice',
    CURRENT_YEAR: 'Trenutno leto',
    PREVIOUS_YEAR: 'Prejšnje leto',
    CUSTOM: 'Prilagojeno',
    NEW_TABLE: 'Nova {name}',
    EDIT_TABLE: 'Uredi {name}',
    FOCUS_TABLE: 'Fokusiraj {name}',
    ROUND: 'Zaokroži',
    REGRESSION: 'Regresija',
    RANDOM: 'Naključno',
    SET_VALUE: 'Nastavi vrednost',
    APPLY_PERCENTAGE: 'Uporabi odstotek',
    APPLY_PERCENTAGE_CHAR: 'Uporabi %',
    DELETE_COLUMNS_ON_ROW: 'Izbriši stolpce v vrstici',
    PROCESSING_FILE: 'Obdelava datoteke',
    IMAGE_PREVIEW_FAILED: 'Predogleda slike ni mogoče prikazati',
    NEXT: 'Naprej',
    PREVIOUS: 'Nazaj',
    PAGE_OF: 'Stran {pageNumber} od {pages}',
    NO_TITLE: 'Brez naslova',
    DURATION: 'Trajanje',
    CELL_COUNT: 'Število celic',
    NONCALCULATED: 'Neizračunano',
    CALCULATED: 'Izračunano',
    SEARCH_ASSIGNMENTS: 'Išči naloge',
    BY_NAME: 'Po imenu',
    BY_LABEL: 'Po oznaki',
    BY_STATUS: 'Po statusu',
    BY_SHEET: 'Po preglednici',
    GROUP_BY: 'Združi po',
    CHART_SPACING: 'Razmik grafikona',
    GRID_COLUMNS: 'Stolpci mreže',
    GRID_SPACING: 'Razmik mreže',
    AXIS_SPACING: 'Razmik osi',
    RESET_FILTERS: 'Ponastavi filtre',
    RESET_CONFIG: 'Ponastavi konfiguracijo',
    RESET_CONFIG_TOOLTIP: 'Ponastavi stanje iskalnika, filtre, časovnico in možnosti preglednice na privzeto konfiguracijo.',
    BY_ASSIGNEE: 'Po dodeljencu',
    BY_APPROVER: 'Po odobritelju',
    NEW_ASSIGNMENT: 'Nova naloga',
    NEXT_ASSGN_DUE: 'Naslednja naloga zapade ',
    SHARE_SELECT_USER_PLACEHOLDER: 'Išči uporabnike ali skupine...',
    CREATE_ASSIGNMENT_PLACEHOLDER: 'Išči uporabnika za dodelitev preglednice...',
    ASSIGNMENT_REFRESHED: 'Rok nalog podaljšan za 7 dni',
    CANT_EDIT_ASSIGNMENT: 'Ni mogoče urejati že oddanih nalog',
    NO_CHANGES: 'Brez sprememb',
    APPROVED: 'Odobreno',
    EXPIRED: 'Poteklo',
    READY_FOR_REVIEW: 'Pripravljeno za pregled',
    IN_PROGRESS: 'V teku',
    SHARED: 'Deljeno',
    SHARED_WITH: 'Deljeno z',
    SHARED_WITH_ME: 'Deljeno z mano',
    SHARED_WITH_ME_TRUNCATED: 'Prikazanih je samo prvih {limit} deljenih elementov',
    ARCHIVED: 'Arhivirano',
    STILL_STUCK: 'Še vedno obtičali? Obiščite naš center za pomoč.',
    NEED_HELP: 'Potrebujete pomoč? Obiščite naš center za pomoč.',
    WELCOME: 'Dobrodošli',
    WELCOME_MESSAGE: 'Izberite nekaj iz stranske vrstice za začetek ali poiščite nekaj določenega.',
    DEFAULT_MEMBER: 'Privzeti član',
    FAILED_TO_LOAD_MODEL: 'Nalaganje modela ni uspelo',
    MODEL_LOADED: 'Model naložen',
    PREVIOUS_MESSAGE_IS_PROCESSING: 'Vaše prejšnje sporočilo se obdeluje. Prosimo, počakajte...',
    RUN_ARGUMENTS: 'Argumenti zagona',
    EXPECTED_ARGUMENTS: 'Pričakovani argumenti',
    RUN_ARGUMENTS_ERROR: 'Argumenti zagona za dejanje so zastareli, prosimo, posodobite jih.',
    RUNS: 'Zagoni',
    PIPELINE: 'Proces',
    PIPELINE_TAB_NO_RUNS: 'Zaženite to aplikacijo, da vidite njen proces.',
    PIPELINE_TAB_NO_MARKERS: 'Zagoni tega procesa ne beležijo svojih korakov. Dodajte experimental__emit_pipeline_visualization_markers=True v run_pipeline v main.py.',
    PIPELINE_STEP_TYPE_MAP: {
        extraction: 'Izvleci',
        parse: 'Razčleni',
        transform: 'Preoblikuj',
        load: 'Naloži',
        export: 'Izvozi',
        unknown: 'Korak',
    },
    PIPELINE_STEP_STATUS_MAP: {
        PENDING: 'Na čakanju',
        RUNNING: 'Se izvaja',
        OK: 'Dokončano',
        EXTRACTED: 'Izvlečeno',
        LOADED: 'Naloženo',
        EXPORTED: 'Izvoženo',
        SKIPPED: 'Preskočeno',
        FAILED: 'Neuspešno',
    },
    PIPELINE_STEP_POSITION: 'Korak {index} od {total}',
    PIPELINE_STEP_ARIA_LABEL: 'Korak procesa {name}, stanje {status}',
    PIPELINE_QUALITY_WARNINGS: '{count} opozoril{{o|a}} o kakovosti',
    PIPELINE_DATASET_COUNT: '{count} {{nabor podatkov|naborov podatkov}}',
    PIPELINE_COMPLETED_IN: 'Dokončano v {duration}',
    PIPELINE_STEPS_EXECUTED: 'Izvedenih {done}/{total} korakov',
    PIPELINE_STEPS_DONE: 'Dokončanih {done}/{total} korakov',
    PIPELINE_FAILED_BEFORE_STEPS: 'Proces ni uspel, preden se je izvedel kateri koli korak: {error}',
    PIPELINE_NO_STEPS: 'Ni najdenih korakov procesa',
    ROWS: 'Vrstic',
    DEPENDS_ON: 'Odvisno od',
    SOURCE: 'Vir',
    SECONDS_SHORT: '{seconds}s',
    SYSTEM: 'sistem',
    BASIC_INFO: 'Osnovni podatki',
    LAST_RUN: 'Zadnji zagon',
    NEVER_RUN: 'Nikoli zagnano',
    REMOTE_JOB_NAME: 'Ime aplikacije',
    CHOOSE_FOLDER: 'Izberite mapo',
    SOURCE_FOLDER: 'Izvorna mapa',
    SELECT_SOURCE_FOLDER_WARNING: 'Prosimo, izberite izvorno mapo',
    MAIN_FILE_HINT: 'pritisnite na oznako datoteke, da jo označite kot vstopno točko skripta',
    NO_FILES: 'Ni datotek',
    NO_MAIN_FILE: 'Ni glavne datoteke',
    FINDER_TOOLTIP: 'Prikaži iskalnik',
    VARIABLE_TOOLTIP: 'Prikaži vrstico spremenljivk',
    sheet_ITEMS_TOOLTIP: 'Prikaži elemente preglednice',
    LIST_ITEMS_TOOLTIP: 'Prikaži elemente seznama',
    EXPAND_TOOLTIP: 'Razširi vse vrstice za eno raven',
    COLLAPSE_TOOLTIP: 'Strni vse vrstice za eno raven',
    UNDO_TOOLTIP: 'Razveljavi',
    REDO_TOOLTIP: 'Uveljavi znova',
    UNDO_HISTORY_RESET: 'Zgodovina razveljavitev je bila ponastavljena',
    UNDO_UNAVAILABLE_NOT_SUPPORTED: 'Te spremembe ni mogoče razveljaviti',
    UNDO_UNAVAILABLE_TOO_LARGE: 'Ta sprememba je prevelika za razveljavitev',
    UNDO_UNAVAILABLE_NO_INVERSE: 'Razveljavitev ni več na voljo',
    UNDO_UNAVAILABLE_NO_LONGER_ALLOWED: 'Te spremembe ni več mogoče razveljaviti',
    UNDO_UNAVAILABLE_GENERIC: 'Te spremembe ni mogoče razveljaviti',
    FORECAST_TOOLTIP: 'Prikaži napredek napovedi',
    EXPORT_TOOLTIP: 'Izvozi v .xlsx',
    APP_SHORTCUTS_TOOLTIP: 'Bližnjice aplikacije',
    TAGS_SIDEBAR_TOOLTIP: 'Odpri stransko vrstico objektov baze podatkov',
    TILE_SIDEBAR_TOOLTIP: 'Odpri stransko vrstico za urejanje ploščic',
    COMMENTS_SIDEBAR_TOOLTIP: 'Odpri stransko vrstico komentarjev',
    ADD_APP_SHORTCUT: 'Dodaj bližnjico',
    APP_SHORTCUTS_PATH: 'Bližnjice aplikacije',
    CHANGE_SHORTCUT_ACTION: 'Spremeni dejanje',
    REMOVE_SHORTCUT: 'Odstrani bližnjico',
    SHORTCUT_ADDED: 'Bližnjica uspešno dodana',
    SHORTCUT_REMOVED: 'Bližnjica odstranjena',
    SHORTCUT_ALREADY_EXISTS: 'Bližnjica že obstaja',
    CHANGE_ACTION_TITLE: 'Spremeni dejanje',
    CHANGE_ACTION_LABEL: 'Izberite eno od naslednjih dejanj',
    ACTION_CHANGED: 'Dejanje spremenjeno',
    ERROR_FETCHING_APP_DATA: 'Napaka pri pridobivanju podatkov aplikacije',
    ERROR_FETCHING_ACTION_ARGUMENTS: 'Napaka pri pridobivanju argumentov dejanja',
    INVALID_ACTION_ARGUMENTS: 'Neveljavni argumenti dejanja',
    APP_STARTED_SUCCESSFULLY: 'Aplikacija uspešno zagnana',
    CREATE_BACKUP: 'Ustvari varnostno kopijo',
    BACKUP: 'Varnostna kopija',
    CREATE_BACKUP_WARNING: 'Ali ste prepričani, da želite ustvariti novo varnostno kopijo?',
    RESTORE_BACKUP: 'Obnovi varnostno kopijo',
    RESTORE: 'Obnovi',
    RESTORE_BACKUP_WARNING: 'Ali ste prepričani, da želite obnoviti varnostno kopijo {backupPath}?',
    COPY_WORKSPACE: 'Kopiraj delovni prostor',
    SELECT_WORKSPACE: 'Izberi delovni prostor',
    COPY_WORKSPACE_ONTO: 'Kopiraj v {workspace}',
    COPY_WORKSPACE_WARNING: 'Vse v tem delovnem prostoru bo zamenjano s kopijo izbranega delovnega prostora. Najprej bo ustvarjena varnostna kopija tega delovnega prostora, kopiranje pa lahko traja več minut.',
    COPY_WORKSPACE_STARTED: 'Kopiranje delovnega prostora se je začelo. Ta delovni prostor ne bo na voljo, dokler se ne zaključi.',
    SELECT_MONTH: 'Izberite mesec',
    REMOVE_FILTER: 'Odstrani filter',
    FILTER_BY: 'Filtriraj po...',
    STATIC_FILTER: 'Tega filtra ni mogoče spremeniti',
    SELECT_ROW_TO: 'Izberite vrstico za ogled ali urejanje njene spremenljivke',
    EDIT_ARGUMENT: 'Uredi argument',
    ARGUMENT_NAME: 'Ime argumenta',
    DATA_TYPE_STRING: 'Niz',
    DATA_TYPE_BOOLEAN: 'Boolean',
    DEFAULT_VALUE: 'Privzeta vrednost',
    ADD_OPTION: 'Dodaj možnost',
    OPTION_VALUE: 'Vrednost možnosti',
    DROPDOWN_OPTIONS_MUST_BE_UNIQUE: 'Možnosti morajo biti edinstvene',
    DROPDOWN_OPTION_EMPTY: 'Možnost ne sme biti prazna',
    DROPDOWN_DEFAULT_AUTO_HINT: 'Privzeta vrednost ni izbrana — pri shranjevanju se uporabi prva možnost.',
    LOCKED_AT_RUN_TIME: 'Zakleni vrednost ob izvajanju',
    LOCKED_AT_RUN_TIME_TOOLTIP: 'Če je označeno, uporabniki pri zagonu aplikacije te vrednosti ne morejo spremeniti.',
    LOCKED_REQUIRES_DEFAULT: 'Zaklenjeni argument mora imeti privzeto vrednost',
    SECRET: 'Skrivno',
    SECRET_TOOLTIP: 'Vrednost je maskirana med vnosom in v dnevnikih',
    SECRET_SAVED_PLACEHOLDER: 'Pustite prazno za shranjeno skrivnost',
    NAME_REQUIRED: 'Ime je obvezno',
    BACKUP_CREATED: 'Varnostna kopija ustvarjena',
    DOWNLOADING_BACKUP: 'Prenašanje varnostne kopije',
    BACKUP_RESTORED: 'Varnostna kopija obnovljena',
    BACKUP_SEARCH_FAILED: 'Nalaganje varnostnih kopij ni uspelo. Poskusite znova.',
    UPLOAD_BACKUP: 'Naloži varnostno kopijo',
    UPLOADING: 'Nalaganje',
    SHOW_UPLOADED: 'Prikaži naložene',
    INITIATED_BY: 'Sprožil',
    SAVE_AS_IMAGE: 'Shrani kot sliko',
    CREATING_AND_SAVING_IMAGE: 'Ustvarjanje slike in shranjevanje v datoteke...',
    IMAGE_SAVED: 'Slika shranjena!',
    FAILED_TO_SAVE_IMAGE: 'Shranjevanje slike ni uspelo.',
    GOAL_VALUE: 'Ciljna vrednost',
    CURRENT_VALUE: 'Trenutna vrednost',
    PERCENTAGE_MET: '{percentage}% doseženo',
    UNFREEZE_CELLS: 'Odmrzni vrednosti',
    FREEZE_CELLS: 'Zamrzni vrednosti',
    UNSET_GOAL: 'Odstrani vrednost kot cilj',
    SET_GOAL: 'Nastavi vrednost kot cilj',
    INSPECT_VALUE: 'Preglej vrednost',
    EDITING_TILE: 'Urejanje ploščice',
    NO_TILE_SELECTED: 'Prosimo, izberite ploščico.',
    NO_TILE_OPTIONS: 'Ni razpoložljivih možnosti.',
    TILE_NAME: 'Ime ploščice',
    ENTER_TILE_NAME: 'Vnesite ime ploščice',
    USE_FILTERS_FROM: 'Uporabi filtre iz',
    USE_SORT_FROM: 'Uporabi razvrščanje iz',
    USE_TIMELINE_FROM: 'Uporabi časovnico iz',
    SHOW_TILE_SORT: 'Prikaži razvrščanje te ploščice',
    SHOW_TILE_FILTERS: 'Prikaži filtre te ploščice',
    SHOW_TILE_TIMELINE: 'Prikaži časovnico te ploščice',
    DASHBOARD: 'Nadzorna plošča',
    TILE: 'Ploščica',
    TILE_COPIED: 'Ploščica je kopirana!',
    CHART_COLUMN_OPTIONS: 'Možnosti stolpcev',
    CHART_ROW_OPTIONS: 'Možnosti vrstic',
    GENERAL_STYLING: 'Splošno oblikovanje',
    PER_ROW_STYLING: 'Oblikovanje po vrsticah',
    PER_COLUMN_STYLING: 'Oblikovanje po stolpcih',
    TEXT_STYLE: 'Slog besedila',
    ROW_STYLE: 'Slog vrstice',
    COLOR: 'Barva',
    PALETTE: 'Paleta',
    BACKGROUND: 'Ozadje',
    BORDER: 'Rob',
    SHADOW: 'Senca',
    TOP_BORDER: 'Zgornji rob',
    BOTTOM_BORDER: 'Spodnji rob',
    INNER_BORDER: 'Notranji rob',
    RESET_GENERAL_STYLES: 'Ponastavi splošne sloge',
    RESET_ALL_PER_ROW_STYLES: 'Ponastavi vse sloge vrstic',
    RESET_ALL_PER_COLUMN_STYLES: 'Ponastavi vse sloge stolpcev',
    RESET_STYLES: 'Ponastavi sloge',
    ADD_TABLE: 'Nova dimenzijska tabela',
    ADD_VARIABLE: 'Nova spremenljivka',
    ADD_SHEET: 'Nova preglednica',
    ADD_DASHBOARD: 'Nova nadzorna plošča',
    ADD_APP: 'Nova aplikacija',
    ADD_FILE: 'Nova datoteka',
    ADD_FOLDER: 'Nova mapa',
    ENABLED: 'Omogočeno',
    NEW_TEMPLATE: 'Nova predloga',
    EDIT_TEMPLATE: 'Uredi predlogo',
    SAVE_SELECTION_AS_TEMPLATE: 'Shrani izbiro kot predlogo',
    TEMPLATE_CREATED: 'Predloga ustvarjena',
    TEMPLATE_UPDATED: 'Predloga posodobljena',
    TEMPLATE_DELETED: 'Predloga izbrisana',
    TEMPLATE_NAME: 'Ime predloge',
    TEMPLATE_DESCRIPTION: 'Opis predloge',
    QUANTITY: 'Količina',
    ENTER_TEXT: 'Vnesite besedilo',
    ENTER_NAME: 'Vnesite ime',
    ENTER_DESCRIPTION: 'Vnesite opis',
    ENTER_NUMBER: 'Vnesite število',
    PICK_A_DATE: 'Izberite datum',
    ERROR_CREATING_DIMENSION: 'Napaka pri ustvarjanju nove dimenzije',
    ALLOW_MULTI_CREATE: 'Dovoli ustvarjanje več elementov hkrati',
    ALLOW_NAME_DESC_CONN_ON_CREATE: 'Nastavi ime, opis in povezave ob ustvarjanju',
    ALLOW_PROPERTIES_ON_CREATE: 'Nastavi lastnosti ob ustvarjanju',
    NAMING_CONFIG_ENABLED: '(Konfiguracija poimenovanja omogočena)',
    DIMENSION_TABLE: 'Dimenzijska tabela',
    DIMENSION_TABLES: 'Dimenzijske tabele',
    DIMENSION_MEMBER: 'Član dimenzije',
    DIMENSION_MEMBERS: 'Člani dimenzij',
    ASK_WHEN_CREATING: 'Vprašaj ob ustvarjanju',
    PREDEFINED_CONNECTIONS: 'Vnaprej določene povezave',
    REQUIRED: 'Obvezno',
    CHOOSE_A_TABLE_FIRST: 'Izberite dimenzijsko tabelo za nastavitev povezav za to predlogo.',
    BIND_TO_TIMELINE: 'Poveži s časovnico',
    NEW_VARIABLE_COLUMN: 'Nov stolpec spremenljivke',
    NEW_DIMENSION_COLUMN: 'Nov stolpec dimenzije',
    NEW_LOOKUP_COLUMN: 'Nov iskalni stolpec',
    NEW_COMPARISON_COLUMN: 'Nov primerjalni stolpec',
    EDITING_CUSTOM_COLUMN: 'Urejanje prilagojenega stolpca',
    LOOKUP_PROPERTIES: 'Iskalne lastnosti',
    CALCULATION_COLUMN: 'Izračunski stolpec',
    ADD_COLUMNS: 'Dodaj stolpce',
    COLUMN_NAME: 'Ime stolpca',
    DELETE_CUSTOM_COLUMN_CONFIRMATION: 'Ali ste prepričani, da želite izbrisati ta stolpec?',
    AUTOGENERATED_CUSTOM_COLUMN_NAME: 'Pustite prazno za samodejno generirano ime',
    NOTE_INSPECT_VALUE: 'Opomba: Funkcija Preglej vrednost prikazuje samo do 500 vrstic. Za ogled vseh podatkov prosimo izvozite celoten nabor podatkov.',
    COPY_FROM: 'Kopiraj iz',
    COPY_FROM_TAGNAME: 'Kopiraj iz {tag}',
    PREVIEW: 'Predogled',
    DECIMALS: 'Decimalke',
    SIGNS: 'Predznaki',
    NEGATIVE_SIGNS: {
        SIGNED: 'Minus',
        UNSIGNED: 'Oklepaji',
        EXPLICIT: 'Plus/Minus',
    },
    POLARITY_SIGNS: {
        POSITIVE: 'Pozitivno',
        NEGATIVE: 'Negativno',
    },
    BASE_UNIT: 'Osnovna enota',
    BASE_UNITS: {
        ONES: 'Enice',
        THOUSANDS: 'Tisočice',
        THOUSANDS_K: 'Tisoči (k)',
        MILLIONS: 'Milijoni',
        MILLIONS_M: 'Milijoni (m)',
        BILLIONS: 'Milijarde',
        BILLIONS_B: 'Milijarde (b)',
        AUTO: 'Samodejno',
    },
    CURRENCY_UNITS: {
        EUR: '€',
        USD: '$',
        HRK: 'HRK',
    },
    MONTHS: {
        January: 'Januar',
        February: 'Februar',
        March: 'Marec',
        April: 'April',
        May: 'Maj',
        June: 'Junij',
        July: 'Julij',
        August: 'Avgust',
        September: 'September',
        October: 'Oktober',
        November: 'November',
        December: 'December',
    },
    MONTHS_SHORT: {
        Jan: 'Jan',
        Feb: 'Feb',
        Mar: 'Mar',
        Apr: 'Apr',
        May: 'Maj',
        Jun: 'Jun',
        Jul: 'Jul',
        Aug: 'Avg',
        Sep: 'Sep',
        Oct: 'Okt',
        Nov: 'Nov',
        Dec: 'Dec',
    },
    DAYS: {
        Sunday: 'Nedelja',
        Monday: 'Ponedeljek',
        Tuesday: 'Torek',
        Wednesday: 'Sreda',
        Thursday: 'Četrtek',
        Friday: 'Petek',
        Saturday: 'Sobota',
    },
    DAYS_SHORT: {
        Sun: 'Ned',
        Mon: 'Pon',
        Tue: 'Tor',
        Wed: 'Sre',
        Thu: 'Čet',
        Fri: 'Pet',
        Sat: 'Sob',
    },
    CURRENCY: 'Valuta',
    SIGNING_IN: 'Prijavljanje...',
    NEW_RELATION_COLUMN: 'Nov stolpec relacije',
    SELECT_TABLE_LOOKUP: 'Izberite tabelo za iskanje',
    SELECT_TABLE_RELATION: 'Povežite člane vrstice z',
    SELECT_TABLE_PROPERTY: 'Izberite lastnost iz tabele',
    DISPLAY_TABLE_PROPERTY: 'Prikaži lastnost iz tabele',
    FILTER_MEMBERS: 'Filtriraj izbiro članov s filtri preglednice',
    TABLE_RELATION: 'Relacija tabele',
    FILTER_DISPLAY: 'Filtriraj prikaz',
    RELATE_TABLE: 'Poveži s tabelo',
    USE_BLANKS: 'Uporabi prazne vrednosti',
    NO_DATA_TO_DISPLAY: 'Ni podatkov za prikaz',
    USE_REFERENCE_SORT: 'Uporabi njegovo razvrščanje',
    USE_REFERENCE_FILTERS: 'Uporabi njene filtre',
    USE_REFERENCE_TIMELINE: 'Uporabi njeno časovnico',
    USE_REFERENCE_TEMPLATES: 'Uporabi njegove predloge',
    USE_REFERENCE_ROWS: 'Uporabi njene vrstice',
    USE_REFERENCE_COLUMNS: 'Uporabi njene stolpce',
    REFERENCE_ANOTHER_SHEET: 'Sklicuj se na drugo preglednico',
    NO_SHEET_SELECTED: 'Nobena preglednica ni izbrana',
    SELECT_SHEET: 'Izberite preglednico',
    SHEET_REFERENCED: 'Preglednica uspešno povezana',
    CANNOT_ADD_ROWS: 'Ni mogoče dodati vrstic med sklicevanjem',
    CANNOT_EDIT_ROWS: 'Ni mogoče urejati vrstic med sklicevanjem',
    CANNOT_EDIT_COLUMNS: 'Ni mogoče urejati stolpcev med sklicevanjem',
    CANNOT_ADD_COLUMNS: 'Ni mogoče dodati stolpcev med sklicevanjem',
    CANNOT_ADD_FILTERS: 'Ni mogoče dodati filtrov med sklicevanjem',
    REVERSE_DIMENSION: 'obratno povezana dimenzija',
    REMOVE_FROM_RULE: 'Odstrani iz pravila',
    NEW_RULE: 'Novo pravilo',
    DUPLICATE_RULE: 'Podvoji pravilo',
    REMOVE_RULE: 'Odstrani pravilo',
    ENABLE_RULE: 'Omogoči pravilo',
    DISABLE_RULE: 'Onemogoči pravilo',
    RULE_DISABLED: 'Onemogočeno',
    VARIABLE_LOCK_INFO_TITLE: 'Ta spremenljivka bo uporabila samo to pravilo.',
    VARIABLE_LOCK_INFO_BODY: 'Druga pravila bodo preglašena. Za zaklepanje celotne spremenljivke pustite razdelek dimenzij prazen.',
    DELETED: 'Izbrisano',
    DONE: 'Končano',
    CHOOSE_ITEMS_TO_EXPORT: 'Izberite elemente za izvoz',
    UPLOAD_MODEL_FILE: 'Naložite datoteko modela',
    NO_FILE_SELECTED: 'Nobena datoteka ni izbrana',
    BACK: 'Nazaj',
    ALLOW_IMPORT_TO: 'Dovoli uvoz v',
    FINISHED: 'Končano',
    IMPORT_PREVIEW: 'To je predogled sprememb, ki bi jih uvoz uporabil s trenutnimi nastavitvami.\n\nSpremembe:\n',
    IMPORT_FINISHED: 'Uvoz končan.\n\nSpremembe:\n',
    LOADING_MODEL: 'Uvažanje modela iz datoteke...',
    CUSTOM_COLUMN: 'Prilagojen stolpec',
    EXPAND_ROW_COLUMN_TOOLBAR: 'Razširi orodno vrstico vrstic in stolpcev',
    SEARCH_FOR_EXPRESSIONS: 'Išči funkcije, spremenljivke, dimenzije…',
    NEW: 'Novo',
    SELECT_A_CELL: 'Izberite celico z vrednostjo za ogled formule',
    SELECT_A_CELL_TO_EDIT_ROWS: 'Izberite celico za urejanje vrstic',
    OR_COLUMNS: 'ali stolpcev',
    MANAGE_PERMISSIONS_FOR: 'Upravljaj dovoljenja za "{name}"',
    VIEW_ONLY: 'Samo ogled',
    DATA_EDIT: 'Urejanje podatkov',
    EDIT_OWNED: 'Uredi lastne',
    FULL_EDIT: 'Polno urejanje',
    UNKNOWN_USER: 'Neznan uporabnik',
    UNKNOWN_GROUP: 'Neznana skupina',
    BUTTON_STYLE: 'Slog gumba',
    BUTTON_STYLES: {
        primary: 'Primarni',
        secondary: 'Sekundarni',
        tertiary: 'Terciarni',
        quaternary: 'Kvaternarni',
    },
    APP_ICON: 'Ikona aplikacije',
    LAST_MODIFIED_BY: 'Nazadnje spremenil/a {name}',
    LAST_MODIFIED_BY_COLUMN: 'Nazadnje spremenil/a',
    LAST_MODIFIED_AT_COLUMN: 'Nazadnje spremenjeno',
    SHOW: 'Prikaži',
    FORMULA_QA: 'QA formul',
    TIME_LIMIT: 'Časovna omejitev',
    RESTRICTIONS: 'Omejitve',
    SEARCH_FOR_USERS_GROUPS: 'Išči uporabnike ali skupine…',
    SEARCH_OR_ADD_USERS_GROUPS: 'Išči ali deli z uporabniki, skupinami ali javno…',
    STATUS_TRACKING: 'Sledenje statusu',
    STATUS_TRACKING_MESSAGE: 'Sledenje omogoča uporabniku ali skupini oddajo sprememb in zahtevo vaše odobritve.',
    TRACK_STATUS: 'Sledi statusu',
    STOP_TRACKING: 'Ustavi sledenje',
    RESTART_TRACKING: 'Ponovno zaženi sledenje',
    ALL: 'Vse',
    TRACKED: 'Sledeno',
    UNTRACKED: 'Nesledeno',
    ALL_TRACKED: 'Vse sledene',
    MY_TRACKED: 'Moje sledene',
    MY_APPROVALS: 'Moje odobritve',
    ALL_SHARES: 'Vsa deljenja',
    SUPER_USERS: 'Super uporabniki',
    LOADING_SUPER_USERS: 'Nalaganje super uporabnikov...',
    CANNOT_EDIT_WHEN_TIME_LIMIT: 'Ni mogoče urejati, ko je časovna omejitev aktivna',
    CANNOT_EDIT_WHEN_TRACKED: 'Ni mogoče urejati, ko je status sledenja aktiven',
    EXPORT_SHARES: 'Izvozi deleže',
    SHARE_COPIED: 'Deljenje kopirano!',
    SHARES_COPIED: 'Deljenja kopirana!',
    COPY_SHARE_IN_FOLDER: 'Kopiraj v vse v tej mapi',
    COPY_AND_OVERRIDE_SHARES: 'Kopiraj in prepiši deljenja',
    COPY_AND_OVERRIDE_SHARES_CONFIRMATION: 'Vsa obstoječa deljenja na elementih in mapah v tej mapi bodo zamenjana z deljenji trenutne mape.',
    COPY_ALL_SHARES_IN_FOLDER: 'Kopiraj in prepiši vsa deljenja v tej mapi',
    GRID_SINGLE_CHART_EXPLANATION: 'Posamezen grafikon z vrsticami najvišje ravni',
    GRID_MULTIPLE_CHART_EXPLANATION: 'Mreža majhnih grafikonov, eden za vsako vrstico najvišje ravni',
    DUPLICATE_KEYS_FOUND: 'Najdeni podvojeni ključi',
    DUPLICATE_KEYS_PROMPT: 'Ali želite filtrirati in ustvariti samo edinstvene elemente?',
    NAMES_SHOULD_BE_UNIQUE: 'Imena morajo biti edinstvena',
    LIMIT_TO_FILTERED_OPTIONS: 'Omeji na filtrirane možnosti',

    // Toast messages
    SWITCHING_TENANT: 'Preklapljanje delovnega prostora',
    TENANT_SWITCHED_SUCCESS: 'Delovni prostor uspešno preklopljen',
    TENANT_SWITCH_FAILED: 'Nalaganje novega delovnega prostora ni uspelo. Prosimo, osvežite stran',
    FAILED_LOAD_MESSAGES: 'Nalaganje sporočil ni uspelo',
    NEW_CHAT_CREATED: 'Nov klepet ustvarjen!',
    FAILED_LOAD_CHATS: 'Nalaganje klepetov ni uspelo.',
    FAILED_CREATE_CHAT: 'Ustvarjanje novega klepeta ni uspelo.',
    FAILED_SEND_MESSAGE: 'Ustvarjanje novega klepeta ali pošiljanje sporočila ni uspelo.',
    FAILED_RENAME_CHAT: 'Preimenovanje klepeta ni uspelo.',
    FAILED_DELETE_CHAT: 'Brisanje klepeta ni uspelo.',
    XLSX_FILE_ONLY: 'Samo datoteke .xlsx',
    JSON_FILE_ONLY: 'Samo datoteke .json',
    EXPORT_DONE: 'Končano!',
    LOCKS_SAVED: 'Zaklepanja shranjena',
    COPIED_TO_CLIPBOARD: 'Kopirano v odložišče',
    INVALID_INTERVAL: 'Neveljaven interval',
    SELECT_REQUIRED_DIMENSIONS: 'Izberite zahtevane dimenzije.',
    ENTITY_TYPE_NOT_SPECIFIED: 'Vrsta entitete ni določena',

    // Button labels
    OK: 'V redu',
    DELETE_ENTITY: 'Izbriši entiteto',
    SAVE_ENTITY: 'Shrani entiteto',
    GENERATED_ENTITIES: 'Generirane entitete',
    NEW_ENTITY: 'Nova entiteta',
    ENTITIES: 'Entitete',
    SHOW_LOGS: 'Prikaži dnevnike',
    CALCULATE: 'Izračunaj',
    FORMULA_QA_TITLE: 'Formula QA',
    RENAME_CHAT: 'Preimenuj klepet',
    SEND: 'Pošlji',
    EXPORT_CURRENT_SHEET: 'Izvozi trenutno preglednico',
    TERMINATE: 'Prekini',
    CONFIRM_UPDATE: 'Potrdi posodobitev',

    // Form labels and placeholders
    FROM_DATE: 'Od datuma',
    TO_DATE: 'Do datuma',
    AUDIT_TYPE: 'Vrsta revizije',
    SELECT_AUDIT_TYPE: 'Izberite vrsto revizije',
    USER: 'Uporabnik',
    PAGE_SIZE: 'Velikost strani',
    SELECT_PAGE_SIZE: 'Izberite velikost strani',
    SELECT_USER: 'Izberite uporabnika',
    EXPORT_EXPANDED_ROWS: 'Izvozi trenutno razširjene vrstice',
    EXPORT_ALL_ROWS: 'Izvozi vse vrstice',
    EXPORT_FILENAME_LABEL: 'Ime',
    EXPORT_VARIABLE: 'Izvozi spremenljivko',
    EXPORT_FORMAT: 'Oblika izvoza',
    EXPORT_FORMAT_XLSX: '.xlsx (Excel 2007 in novejši)',
    EXPORT_FORMAT_CSV_BOM: '.csv (združljivo z Excelom)',
    EXPORT_FORMAT_CSV: '.csv (čisti podatki)',
    EXPORT_FORMAT_JSON: '.json',
    INCLUDE_MEMBERS: 'Vključi člane',
    MESSAGE_FARSEER_AI: 'Sporočilo za FarseerAI...',
    ENTER_NEW_CHAT_NAME: 'Vnesite novo ime klepeta',
    FLAG: 'Zastavica',

    // Chat suggestions
    CHAT_SUGGESTION_SUMMARY: 'Podaj mi kratek povzetek modela',
    CHAT_SUGGESTION_DIMENSIONS: 'Ali obstajajo spremenljivke, ki imajo več dimenzij kot spremenljivke v njihovi formuli?',
    CHAT_SUGGESTION_DELAY: 'Ali katera spremenljivka uporablja funkcijo delay()?',
    CHAT_SUGGESTION_ONDEMAND: 'Naštej vse spremenljivke na zahtevo',
    CHAT_SUGGESTION_MEASURES: 'Naštej vse mere',
    CHAT_SUGGESTION_FIXED: 'Naštej vse spremenljivke, ki uporabljajo fiksno dimenzijo',
    CHAT_SUGGESTION_DATE: 'Naštej vse dimenzije, ki imajo lastnost datuma',

    // Loading defaults
    DEFAULT_LOADING: 'Nalaganje...',
    DEFAULT_SUCCESS: 'Uspeh!',

    // Audit logs
    TOTAL_RESULTS: 'Skupno rezultatov: {count}',
    PAGE_OF_TOTAL: 'Stran {current} od {total}',
    DB_ID: 'ID baze',
    DATE_AND_TIME: 'Datum in čas',
    LOG_TYPE: 'Vrsta dnevnika',
    DATA: 'Podatki',

    // Entity debugger
    NO_TYPES: 'Ni vrst',

    // Formula QA Modal
    RESULT: 'Rezultat: {value}',
    ENTER_FORMULA_TO_CALCULATE: 'Vnesite formulo za izračun rezultata.',

    // Model export
    EXPORTING_MODEL_ITEMS: 'Izvažanje izbranih elementov modela...',

    // Search
    RECENTLY_SEARCHED: 'Nedavno iskano',

    // Compound formulas
    UNPARSEABLE_COMPOUND_FORMULA: 'Ta formula je preveč zapletena, da bi jo bilo mogoče predstaviti kot sestavljena pravila',

    // Datasets
    DATASET_CURRENT_VERSION: 'Trenutna različica',
    DATASET_NOT_CURRENT_VERSION: 'Ni trenutna različica.',
    DATASET_ROW_COUNT: '{rows} {{vrstica|vrstice}}',
    DATASET_ROWS_WRITTEN: 'Zapisane vrstice',
    DATASET_SIZE_WRITTEN: 'Zapisana velikost',
    DATASET_ROW_COUNT_PREVIEW_LIMITED: '{rows} vrstic, prikazanih prvih {shown}',
    DATASET_PREVIEW_UNSUPPORTED_FORMAT: 'Predogled bere različice parquet in CSV. Prenesite to različico, da jo odprete.',
    DATASET_PREVIEW_TOO_LARGE: 'Ta različica je prevelika za predogled. Prenesite jo, da jo odprete.',
    DATASET_WRITTEN_BY: 'Zapisal',
    DATASET_OPENED_FROM: 'Odprto iz',
    DATASET_FROM_OPENED_RUN: 'Zapisano z odprtim zagonom',
    DATASET_SHOW_CURRENT: 'Prikaži trenutno',
    DATASET_VERSION_CANCELLED: 'Ta različica je bila preklicana in nikoli ni postala trenutna.',
    DATASET_VERSION_CANCELLED_EMPTY: 'Ta različica je bila preklicana in nikoli ni postala trenutna. Ne vsebuje podatkov.',
    DATASET_VERSION_STILL_WRITING: 'Ta različica se še zapisuje. Zaenkrat nima podatkov za predogled.',
    DATASET_PREVIEW_FIRST_FILE: 'Ta različica vsebuje {count} datotek. Prikazana je samo {filename}.',
    DATASET_NO_PUBLISHED_VERSION: 'Podatkov še ni. Ta nabor podatkov nima objavljene različice.',
    DATASET_VERSION_NOT_FOUND: 'Ta različica ne obstaja več.',
    DATASET_PREVIEW_FORBIDDEN: 'Nimate dovoljenja za branje tega nabora podatkov.',
    DATASET_COPY_LOADED_ROWS_ONLY: 'Kopirane so bile samo že prikazane vrstice. Prenesite datoteko, da dobite vse vrstice.',
    DATASET_NOT_FOUND: 'Nabor podatkov ni bil najden ali ni dostopen.',
    GO_BACK_TO_DATASETS: 'Nazaj na nabore podatkov',
    OPEN_DATASET: 'Odpri nabor podatkov',
    OPEN_DATASET_VERSION: 'Odpri to različico',
    DATASETS_LOAD_FAILED: 'Nalaganje naborov podatkov ni uspelo',
    PIPELINES_LOAD_FAILED: 'Nalaganje procesov ni uspelo',
    PIPELINES_NO_PERMISSION: 'Za prikaz procesov potrebujete dovoljenje \'{permission}\'.',
    DATASET_DELETE_CONFIRM: 'Izbriši nabor podatkov {name}? S tem odstranite vse njegove različice in tega dejanja ni mogoče razveljaviti.',
    DATASET_VERSION_HISTORY: 'Zgodovina različic',
    DATASET_VERSION_COUNT: '{count} {{različica|različic}}',
    DATASET_VERSIONS_LOAD_FAILED: 'Nalaganje različic ni uspelo',
    DATASET_VERSION_STARTED: 'Začeto',
    DATASET_VERSION_PUBLISHED: 'Objavljeno',
    DATASET_VERSION_STATUS_MAP: {
        current: 'Trenutno',
        published: 'Objavljeno',
        candidate: 'Dokončano, ni objavljeno',
        writing: 'Pisanje',
    },
    DATASET_VERSION_CANCELLATION_MAP: {
        manual: 'Preklicano',
        run_closed: 'Izvajanje se je končalo pred objavo',
        run_failed: 'Izvajanje ni uspelo',
        validation_failed: 'Preverjanje ni uspelo',
        superseded_by_retry: 'Nadomeščeno z novejšim izvajanjem',
        publication_conflict: 'Ni objavljeno: trenutna različica se je med izvajanjem spremenila',
        expired: 'Ni bilo objavljeno v 24 urah',
        legacy_cancelled: 'Preklicano (pred sledenjem zgodovini)',
    },
    DATASET_VERSION_PUBLICATION_CONFLICT: 'Ni objavljeno: {version} je med izvajanjem postala trenutna',
    DATASET_MAKE_CURRENT: 'Nastavi kot trenutno',
    DATASET_MAKE_CURRENT_TITLE: 'Nastavim {version} kot trenutno?',
    DATASET_MAKE_CURRENT_QUESTION: 'Poznejša branja nabora podatkov {dataset} uporabljajo {version}. To vključuje korake nalaganja, druge cevovode in predogled. Podatki, ki jih je model Farseer že naložil iz tega nabora podatkov, se ne spremenijo.',
    DATASET_MAKE_CURRENT_WARNING: 'Izvajanje cevovoda, ki v tem trenutku zapisuje v ta nabor podatkov, ne bo uspelo in njegova neobjavljena različica bo preklicana. Če nabor podatkov sledi svojemu položaju branja v viru, se položaj premakne nazaj do mesta, kjer se je {version} ustavila.',
    DATASET_MAKE_CURRENT_NO_PERMISSION: 'Za spremembo trenutne različice potrebujete dovoljenje »{permission}«.',
    DATASET_PUBLISH: 'Objavi',
    DATASET_PUBLISH_TITLE: 'Objavim {version}?',
    DATASET_PUBLISH_QUESTION: 'Z objavo {version} postane trenutna različica. Izvajanje njenega cevovoda je ni objavilo: izvajanje se je ustavilo predčasno ali pa še vedno poteka.',
    DATASET_PUBLISH_WARNING: 'Objava preskoči preverjanja, ki jih izvajanje opravi pred objavo.',
};

export default {
    ...(baseLanguageValues as Translation),
    ...translationValues,
};
